// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../node_modules/@fontsource/inconsolata/files/inconsolata-vietnamese-400-normal.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../node_modules/@fontsource/inconsolata/files/inconsolata-vietnamese-400-normal.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../node_modules/@fontsource/inconsolata/files/inconsolata-latin-ext-400-normal.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../node_modules/@fontsource/inconsolata/files/inconsolata-latin-ext-400-normal.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../../node_modules/@fontsource/inconsolata/files/inconsolata-latin-400-normal.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../../node_modules/@fontsource/inconsolata/files/inconsolata-latin-400-normal.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../../node_modules/@fontsource/inconsolata/files/inconsolata-vietnamese-500-normal.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../../node_modules/@fontsource/inconsolata/files/inconsolata-vietnamese-500-normal.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../../node_modules/@fontsource/inconsolata/files/inconsolata-latin-ext-500-normal.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../../../node_modules/@fontsource/inconsolata/files/inconsolata-latin-ext-500-normal.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../../../node_modules/@fontsource/inconsolata/files/inconsolata-latin-500-normal.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../../../node_modules/@fontsource/inconsolata/files/inconsolata-latin-500-normal.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*! tailwindcss v4.2.0 | MIT License | https://tailwindcss.com */
@layer properties;
@layer theme, base, components, utilities;
@layer theme {
  :root, :host {
    --font-sans: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji",
      "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    --font-mono: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono",
      "Courier New", monospace;
    --color-red-300: oklch(80.8% 0.114 19.571);
    --color-red-400: oklch(70.4% 0.191 22.216);
    --color-red-500: oklch(63.7% 0.237 25.331);
    --color-orange-400: oklch(75% 0.183 55.934);
    --color-orange-500: oklch(70.5% 0.213 47.604);
    --color-amber-400: oklch(82.8% 0.189 84.429);
    --color-amber-500: oklch(76.9% 0.188 70.08);
    --color-yellow-400: oklch(85.2% 0.199 91.936);
    --color-yellow-500: oklch(79.5% 0.184 86.047);
    --color-green-400: oklch(79.2% 0.209 151.711);
    --color-green-500: oklch(72.3% 0.219 149.579);
    --color-cyan-400: oklch(78.9% 0.154 211.53);
    --color-cyan-500: oklch(71.5% 0.143 215.221);
    --color-blue-400: oklch(70.7% 0.165 254.624);
    --color-blue-500: oklch(62.3% 0.214 259.815);
    --color-purple-400: oklch(71.4% 0.203 305.504);
    --color-purple-500: oklch(62.7% 0.265 303.9);
    --color-gray-400: oklch(70.7% 0.022 261.325);
    --color-gray-500: oklch(55.1% 0.027 264.364);
    --color-black: #000;
    --color-white: #fff;
    --spacing: 0.25rem;
    --container-md: 28rem;
    --text-xs: 0.75rem;
    --text-xs--line-height: calc(1 / 0.75);
    --text-sm: 0.875rem;
    --text-sm--line-height: calc(1.25 / 0.875);
    --font-weight-normal: 400;
    --font-weight-medium: 500;
    --font-weight-semibold: 600;
    --font-weight-bold: 700;
    --tracking-normal: 0em;
    --tracking-wide: 0.025em;
    --tracking-wider: 0.05em;
    --tracking-widest: 0.1em;
    --leading-snug: 1.375;
    --leading-relaxed: 1.625;
    --radius-md: 0.375rem;
    --radius-lg: 0.5rem;
    --animate-spin: spin 1s linear infinite;
    --default-transition-duration: 150ms;
    --default-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    --default-font-family: var(--font-sans);
    --default-mono-font-family: var(--font-mono);
  }
}
@layer base {
  *, ::after, ::before, ::backdrop, ::file-selector-button {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    border: 0 solid;
  }
  html, :host {
    line-height: 1.5;
    -webkit-text-size-adjust: 100%;
    tab-size: 4;
    font-family: var(--default-font-family, ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji");
    font-feature-settings: var(--default-font-feature-settings, normal);
    font-variation-settings: var(--default-font-variation-settings, normal);
    -webkit-tap-highlight-color: transparent;
  }
  hr {
    height: 0;
    color: inherit;
    border-top-width: 1px;
  }
  abbr:where([title]) {
    -webkit-text-decoration: underline dotted;
    text-decoration: underline dotted;
  }
  h1, h2, h3, h4, h5, h6 {
    font-size: inherit;
    font-weight: inherit;
  }
  a {
    color: inherit;
    -webkit-text-decoration: inherit;
    text-decoration: inherit;
  }
  b, strong {
    font-weight: bolder;
  }
  code, kbd, samp, pre {
    font-family: var(--default-mono-font-family, ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace);
    font-feature-settings: var(--default-mono-font-feature-settings, normal);
    font-variation-settings: var(--default-mono-font-variation-settings, normal);
    font-size: 1em;
  }
  small {
    font-size: 80%;
  }
  sub, sup {
    font-size: 75%;
    line-height: 0;
    position: relative;
    vertical-align: baseline;
  }
  sub {
    bottom: -0.25em;
  }
  sup {
    top: -0.5em;
  }
  table {
    text-indent: 0;
    border-color: inherit;
    border-collapse: collapse;
  }
  :-moz-focusring {
    outline: auto;
  }
  progress {
    vertical-align: baseline;
  }
  summary {
    display: list-item;
  }
  ol, ul, menu {
    list-style: none;
  }
  img, svg, video, canvas, audio, iframe, embed, object {
    display: block;
    vertical-align: middle;
  }
  img, video {
    max-width: 100%;
    height: auto;
  }
  button, input, select, optgroup, textarea, ::file-selector-button {
    font: inherit;
    font-feature-settings: inherit;
    font-variation-settings: inherit;
    letter-spacing: inherit;
    color: inherit;
    border-radius: 0;
    background-color: transparent;
    opacity: 1;
  }
  :where(select:is([multiple], [size])) optgroup {
    font-weight: bolder;
  }
  :where(select:is([multiple], [size])) optgroup option {
    padding-inline-start: 20px;
  }
  ::file-selector-button {
    margin-inline-end: 4px;
  }
  ::placeholder {
    opacity: 1;
  }
  @supports (not (-webkit-appearance: -apple-pay-button))  or (contain-intrinsic-size: 1px) {
    ::placeholder {
      color: currentcolor;
      @supports (color: color-mix(in lab, red, red)) {
        color: color-mix(in oklab, currentcolor 50%, transparent);
      }
    }
  }
  textarea {
    resize: vertical;
  }
  ::-webkit-search-decoration {
    -webkit-appearance: none;
  }
  ::-webkit-date-and-time-value {
    min-height: 1lh;
    text-align: inherit;
  }
  ::-webkit-datetime-edit {
    display: inline-flex;
  }
  ::-webkit-datetime-edit-fields-wrapper {
    padding: 0;
  }
  ::-webkit-datetime-edit, ::-webkit-datetime-edit-year-field, ::-webkit-datetime-edit-month-field, ::-webkit-datetime-edit-day-field, ::-webkit-datetime-edit-hour-field, ::-webkit-datetime-edit-minute-field, ::-webkit-datetime-edit-second-field, ::-webkit-datetime-edit-millisecond-field, ::-webkit-datetime-edit-meridiem-field {
    padding-block: 0;
  }
  ::-webkit-calendar-picker-indicator {
    line-height: 1;
  }
  :-moz-ui-invalid {
    box-shadow: none;
  }
  button, input:where([type="button"], [type="reset"], [type="submit"]), ::file-selector-button {
    appearance: button;
  }
  ::-webkit-inner-spin-button, ::-webkit-outer-spin-button {
    height: auto;
  }
  [hidden]:where(:not([hidden="until-found"])) {
    display: none !important;
  }
}
@layer utilities {
  .pointer-events-none {
    pointer-events: none;
  }
  .collapse {
    visibility: collapse;
  }
  .visible {
    visibility: visible;
  }
  .absolute {
    position: absolute;
  }
  .fixed {
    position: fixed;
  }
  .relative {
    position: relative;
  }
  .static {
    position: static;
  }
  .sticky {
    position: sticky;
  }
  .inset-0 {
    inset: calc(var(--spacing) * 0);
  }
  .start {
    inset-inline-start: var(--spacing);
  }
  .end {
    inset-inline-end: var(--spacing);
  }
  .-top-1 {
    top: calc(var(--spacing) * -1);
  }
  .top-0 {
    top: calc(var(--spacing) * 0);
  }
  .top-1\\/2 {
    top: calc(1 / 2 * 100%);
  }
  .-right-1 {
    right: calc(var(--spacing) * -1);
  }
  .bottom-full {
    bottom: 100%;
  }
  .left-0 {
    left: calc(var(--spacing) * 0);
  }
  .left-2\\.5 {
    left: calc(var(--spacing) * 2.5);
  }
  .z-50 {
    z-index: 50;
  }
  .container {
    width: 100%;
    @media (width >= 40rem) {
      max-width: 40rem;
    }
    @media (width >= 48rem) {
      max-width: 48rem;
    }
    @media (width >= 64rem) {
      max-width: 64rem;
    }
    @media (width >= 80rem) {
      max-width: 80rem;
    }
    @media (width >= 96rem) {
      max-width: 96rem;
    }
  }
  .mt-0\\.5 {
    margin-top: calc(var(--spacing) * 0.5);
  }
  .mt-1 {
    margin-top: calc(var(--spacing) * 1);
  }
  .mt-2 {
    margin-top: calc(var(--spacing) * 2);
  }
  .mt-3 {
    margin-top: calc(var(--spacing) * 3);
  }
  .mt-5 {
    margin-top: calc(var(--spacing) * 5);
  }
  .mb-1 {
    margin-bottom: calc(var(--spacing) * 1);
  }
  .mb-2 {
    margin-bottom: calc(var(--spacing) * 2);
  }
  .mb-3 {
    margin-bottom: calc(var(--spacing) * 3);
  }
  .mb-5 {
    margin-bottom: calc(var(--spacing) * 5);
  }
  .ml-1 {
    margin-left: calc(var(--spacing) * 1);
  }
  .ml-2 {
    margin-left: calc(var(--spacing) * 2);
  }
  .ml-auto {
    margin-left: auto;
  }
  .block {
    display: block;
  }
  .contents {
    display: contents;
  }
  .flex {
    display: flex;
  }
  .grid {
    display: grid;
  }
  .hidden {
    display: none;
  }
  .inline {
    display: inline;
  }
  .inline-flex {
    display: inline-flex;
  }
  .table {
    display: table;
  }
  .h-1 {
    height: calc(var(--spacing) * 1);
  }
  .h-2\\.5 {
    height: calc(var(--spacing) * 2.5);
  }
  .h-4 {
    height: calc(var(--spacing) * 4);
  }
  .h-6 {
    height: calc(var(--spacing) * 6);
  }
  .h-12 {
    height: calc(var(--spacing) * 12);
  }
  .h-16 {
    height: calc(var(--spacing) * 16);
  }
  .h-32 {
    height: calc(var(--spacing) * 32);
  }
  .h-full {
    height: 100%;
  }
  .min-h-0 {
    min-height: calc(var(--spacing) * 0);
  }
  .w-1\\.5 {
    width: calc(var(--spacing) * 1.5);
  }
  .w-2\\.5 {
    width: calc(var(--spacing) * 2.5);
  }
  .w-3 {
    width: calc(var(--spacing) * 3);
  }
  .w-4 {
    width: calc(var(--spacing) * 4);
  }
  .w-6 {
    width: calc(var(--spacing) * 6);
  }
  .w-12 {
    width: calc(var(--spacing) * 12);
  }
  .w-16 {
    width: calc(var(--spacing) * 16);
  }
  .w-48 {
    width: calc(var(--spacing) * 48);
  }
  .w-full {
    width: 100%;
  }
  .max-w-\\[85\\%\\] {
    max-width: 85%;
  }
  .max-w-md {
    max-width: var(--container-md);
  }
  .min-w-0 {
    min-width: calc(var(--spacing) * 0);
  }
  .min-w-\\[120px\\] {
    min-width: 120px;
  }
  .min-w-\\[140px\\] {
    min-width: 140px;
  }
  .flex-1 {
    flex: 1;
  }
  .flex-shrink-0 {
    flex-shrink: 0;
  }
  .shrink-0 {
    flex-shrink: 0;
  }
  .grow {
    flex-grow: 1;
  }
  .-translate-y-1\\/2 {
    --tw-translate-y: calc(calc(1 / 2 * 100%) * -1);
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .transform {
    transform: var(--tw-rotate-x,) var(--tw-rotate-y,) var(--tw-rotate-z,) var(--tw-skew-x,) var(--tw-skew-y,);
  }
  .animate-spin {
    animation: var(--animate-spin);
  }
  .cursor-help {
    cursor: help;
  }
  .cursor-not-allowed {
    cursor: not-allowed;
  }
  .cursor-pointer {
    cursor: pointer;
  }
  .cursor-row-resize {
    cursor: row-resize;
  }
  .cursor-text {
    cursor: text;
  }
  .touch-none {
    touch-action: none;
  }
  .resize {
    resize: both;
  }
  .resize-none {
    resize: none;
  }
  .resize-y {
    resize: vertical;
  }
  .list-disc {
    list-style-type: disc;
  }
  .flex-col {
    flex-direction: column;
  }
  .flex-wrap {
    flex-wrap: wrap;
  }
  .items-center {
    align-items: center;
  }
  .items-start {
    align-items: flex-start;
  }
  .justify-between {
    justify-content: space-between;
  }
  .justify-center {
    justify-content: center;
  }
  .justify-end {
    justify-content: flex-end;
  }
  .gap-1 {
    gap: calc(var(--spacing) * 1);
  }
  .gap-1\\.5 {
    gap: calc(var(--spacing) * 1.5);
  }
  .gap-2 {
    gap: calc(var(--spacing) * 2);
  }
  .gap-2\\.5 {
    gap: calc(var(--spacing) * 2.5);
  }
  .gap-3 {
    gap: calc(var(--spacing) * 3);
  }
  .gap-4 {
    gap: calc(var(--spacing) * 4);
  }
  .space-y-1 {
    :where(& > :not(:last-child)) {
      --tw-space-y-reverse: 0;
      margin-block-start: calc(calc(var(--spacing) * 1) * var(--tw-space-y-reverse));
      margin-block-end: calc(calc(var(--spacing) * 1) * calc(1 - var(--tw-space-y-reverse)));
    }
  }
  .gap-x-3 {
    column-gap: calc(var(--spacing) * 3);
  }
  .gap-y-1 {
    row-gap: calc(var(--spacing) * 1);
  }
  .self-end {
    align-self: flex-end;
  }
  .self-start {
    align-self: flex-start;
  }
  .self-stretch {
    align-self: stretch;
  }
  .truncate {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .overflow-auto {
    overflow: auto;
  }
  .overflow-x-auto {
    overflow-x: auto;
  }
  .overflow-x-hidden {
    overflow-x: hidden;
  }
  .overflow-y-auto {
    overflow-y: auto;
  }
  .rounded {
    border-radius: 0.25rem;
  }
  .rounded-full {
    border-radius: calc(infinity * 1px);
  }
  .rounded-lg {
    border-radius: var(--radius-lg);
  }
  .rounded-md {
    border-radius: var(--radius-md);
  }
  .border {
    border-style: var(--tw-border-style);
    border-width: 1px;
  }
  .border-t {
    border-top-style: var(--tw-border-style);
    border-top-width: 1px;
  }
  .border-b {
    border-bottom-style: var(--tw-border-style);
    border-bottom-width: 1px;
  }
  .border-l-2 {
    border-left-style: var(--tw-border-style);
    border-left-width: 2px;
  }
  .border-none {
    --tw-border-style: none;
    border-style: none;
  }
  .border-\\[var\\(--color-ide-border\\)\\] {
    border-color: var(--color-ide-border);
  }
  .border-red-400 {
    border-color: var(--color-red-400);
  }
  .border-transparent {
    border-color: transparent;
  }
  .border-white\\/20 {
    border-color: color-mix(in srgb, #fff 20%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--color-white) 20%, transparent);
    }
  }
  .bg-\\[var\\(--color-ide-accent\\)\\] {
    background-color: var(--color-ide-accent);
  }
  .bg-\\[var\\(--color-ide-agent-done\\)\\] {
    background-color: var(--color-ide-agent-done);
  }
  .bg-\\[var\\(--color-ide-agent-working\\)\\] {
    background-color: var(--color-ide-agent-working);
  }
  .bg-\\[var\\(--color-ide-bg\\)\\] {
    background-color: var(--color-ide-bg);
  }
  .bg-\\[var\\(--color-ide-border\\)\\] {
    background-color: var(--color-ide-border);
  }
  .bg-\\[var\\(--color-ide-input\\)\\] {
    background-color: var(--color-ide-input);
  }
  .bg-\\[var\\(--color-ide-surface\\)\\] {
    background-color: var(--color-ide-surface);
  }
  .bg-\\[var\\(--color-ide-surface-2\\)\\] {
    background-color: var(--color-ide-surface-2);
  }
  .bg-\\[var\\(--color-ide-surface-hover\\)\\] {
    background-color: var(--color-ide-surface-hover);
  }
  .bg-\\[var\\(--color-ide-surface-hover\\)\\]\\/30 {
    background-color: var(--color-ide-surface-hover);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-ide-surface-hover) 30%, transparent);
    }
  }
  .bg-amber-500\\/10 {
    background-color: color-mix(in srgb, oklch(76.9% 0.188 70.08) 10%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-amber-500) 10%, transparent);
    }
  }
  .bg-black\\/50 {
    background-color: color-mix(in srgb, #000 50%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-black) 50%, transparent);
    }
  }
  .bg-blue-500\\/10 {
    background-color: color-mix(in srgb, oklch(62.3% 0.214 259.815) 10%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-blue-500) 10%, transparent);
    }
  }
  .bg-blue-500\\/20 {
    background-color: color-mix(in srgb, oklch(62.3% 0.214 259.815) 20%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-blue-500) 20%, transparent);
    }
  }
  .bg-blue-500\\/30 {
    background-color: color-mix(in srgb, oklch(62.3% 0.214 259.815) 30%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-blue-500) 30%, transparent);
    }
  }
  .bg-cyan-500\\/10 {
    background-color: color-mix(in srgb, oklch(71.5% 0.143 215.221) 10%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-cyan-500) 10%, transparent);
    }
  }
  .bg-cyan-500\\/20 {
    background-color: color-mix(in srgb, oklch(71.5% 0.143 215.221) 20%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-cyan-500) 20%, transparent);
    }
  }
  .bg-gray-500\\/10 {
    background-color: color-mix(in srgb, oklch(55.1% 0.027 264.364) 10%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-gray-500) 10%, transparent);
    }
  }
  .bg-green-500\\/10 {
    background-color: color-mix(in srgb, oklch(72.3% 0.219 149.579) 10%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-green-500) 10%, transparent);
    }
  }
  .bg-orange-500\\/10 {
    background-color: color-mix(in srgb, oklch(70.5% 0.213 47.604) 10%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-orange-500) 10%, transparent);
    }
  }
  .bg-orange-500\\/20 {
    background-color: color-mix(in srgb, oklch(70.5% 0.213 47.604) 20%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-orange-500) 20%, transparent);
    }
  }
  .bg-purple-500\\/10 {
    background-color: color-mix(in srgb, oklch(62.7% 0.265 303.9) 10%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-purple-500) 10%, transparent);
    }
  }
  .bg-purple-500\\/20 {
    background-color: color-mix(in srgb, oklch(62.7% 0.265 303.9) 20%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-purple-500) 20%, transparent);
    }
  }
  .bg-red-500\\/10 {
    background-color: color-mix(in srgb, oklch(63.7% 0.237 25.331) 10%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-red-500) 10%, transparent);
    }
  }
  .bg-red-500\\/20 {
    background-color: color-mix(in srgb, oklch(63.7% 0.237 25.331) 20%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-red-500) 20%, transparent);
    }
  }
  .bg-red-500\\/30 {
    background-color: color-mix(in srgb, oklch(63.7% 0.237 25.331) 30%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-red-500) 30%, transparent);
    }
  }
  .bg-transparent {
    background-color: transparent;
  }
  .bg-yellow-500\\/10 {
    background-color: color-mix(in srgb, oklch(79.5% 0.184 86.047) 10%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-yellow-500) 10%, transparent);
    }
  }
  .bg-yellow-500\\/20 {
    background-color: color-mix(in srgb, oklch(79.5% 0.184 86.047) 20%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-yellow-500) 20%, transparent);
    }
  }
  .bg-yellow-500\\/30 {
    background-color: color-mix(in srgb, oklch(79.5% 0.184 86.047) 30%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-yellow-500) 30%, transparent);
    }
  }
  .object-cover {
    object-fit: cover;
  }
  .p-0\\.5 {
    padding: calc(var(--spacing) * 0.5);
  }
  .p-1 {
    padding: calc(var(--spacing) * 1);
  }
  .p-2 {
    padding: calc(var(--spacing) * 2);
  }
  .p-3 {
    padding: calc(var(--spacing) * 3);
  }
  .p-px {
    padding: 1px;
  }
  .px-1 {
    padding-inline: calc(var(--spacing) * 1);
  }
  .px-1\\.5 {
    padding-inline: calc(var(--spacing) * 1.5);
  }
  .px-2 {
    padding-inline: calc(var(--spacing) * 2);
  }
  .px-2\\.5 {
    padding-inline: calc(var(--spacing) * 2.5);
  }
  .px-3 {
    padding-inline: calc(var(--spacing) * 3);
  }
  .px-4 {
    padding-inline: calc(var(--spacing) * 4);
  }
  .py-0\\.5 {
    padding-block: calc(var(--spacing) * 0.5);
  }
  .py-1 {
    padding-block: calc(var(--spacing) * 1);
  }
  .py-1\\.5 {
    padding-block: calc(var(--spacing) * 1.5);
  }
  .py-2 {
    padding-block: calc(var(--spacing) * 2);
  }
  .py-3 {
    padding-block: calc(var(--spacing) * 3);
  }
  .py-4 {
    padding-block: calc(var(--spacing) * 4);
  }
  .py-8 {
    padding-block: calc(var(--spacing) * 8);
  }
  .pt-1 {
    padding-top: calc(var(--spacing) * 1);
  }
  .pr-2 {
    padding-right: calc(var(--spacing) * 2);
  }
  .pr-3 {
    padding-right: calc(var(--spacing) * 3);
  }
  .pb-1 {
    padding-bottom: calc(var(--spacing) * 1);
  }
  .pb-2 {
    padding-bottom: calc(var(--spacing) * 2);
  }
  .pl-4 {
    padding-left: calc(var(--spacing) * 4);
  }
  .pl-5 {
    padding-left: calc(var(--spacing) * 5);
  }
  .pl-6 {
    padding-left: calc(var(--spacing) * 6);
  }
  .pl-8 {
    padding-left: calc(var(--spacing) * 8);
  }
  .text-center {
    text-align: center;
  }
  .text-left {
    text-align: left;
  }
  .font-\\[inherit\\] {
    font-family: inherit;
  }
  .font-mono {
    font-family: var(--font-mono);
  }
  .text-sm {
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
  }
  .text-xs {
    font-size: var(--text-xs);
    line-height: var(--tw-leading, var(--text-xs--line-height));
  }
  .text-\\[9px\\] {
    font-size: 9px;
  }
  .text-\\[10px\\] {
    font-size: 10px;
  }
  .text-\\[11px\\] {
    font-size: 11px;
  }
  .text-\\[12px\\] {
    font-size: 12px;
  }
  .text-\\[13px\\] {
    font-size: 13px;
  }
  .leading-relaxed {
    --tw-leading: var(--leading-relaxed);
    line-height: var(--leading-relaxed);
  }
  .leading-snug {
    --tw-leading: var(--leading-snug);
    line-height: var(--leading-snug);
  }
  .font-bold {
    --tw-font-weight: var(--font-weight-bold);
    font-weight: var(--font-weight-bold);
  }
  .font-medium {
    --tw-font-weight: var(--font-weight-medium);
    font-weight: var(--font-weight-medium);
  }
  .font-normal {
    --tw-font-weight: var(--font-weight-normal);
    font-weight: var(--font-weight-normal);
  }
  .font-semibold {
    --tw-font-weight: var(--font-weight-semibold);
    font-weight: var(--font-weight-semibold);
  }
  .tracking-normal {
    --tw-tracking: var(--tracking-normal);
    letter-spacing: var(--tracking-normal);
  }
  .tracking-wide {
    --tw-tracking: var(--tracking-wide);
    letter-spacing: var(--tracking-wide);
  }
  .tracking-wider {
    --tw-tracking: var(--tracking-wider);
    letter-spacing: var(--tracking-wider);
  }
  .tracking-widest {
    --tw-tracking: var(--tracking-widest);
    letter-spacing: var(--tracking-widest);
  }
  .break-words {
    overflow-wrap: break-word;
  }
  .whitespace-nowrap {
    white-space: nowrap;
  }
  .whitespace-pre-wrap {
    white-space: pre-wrap;
  }
  .text-\\[var\\(--color-ide-accent\\)\\] {
    color: var(--color-ide-accent);
  }
  .text-\\[var\\(--color-ide-agent-on-strong\\)\\] {
    color: var(--color-ide-agent-on-strong);
  }
  .text-\\[var\\(--color-ide-error\\)\\] {
    color: var(--color-ide-error);
  }
  .text-\\[var\\(--color-ide-text\\)\\] {
    color: var(--color-ide-text);
  }
  .text-\\[var\\(--color-ide-text-dim\\)\\] {
    color: var(--color-ide-text-dim);
  }
  .text-\\[var\\(--color-ide-text-muted\\)\\] {
    color: var(--color-ide-text-muted);
  }
  .text-amber-400 {
    color: var(--color-amber-400);
  }
  .text-blue-400 {
    color: var(--color-blue-400);
  }
  .text-cyan-400 {
    color: var(--color-cyan-400);
  }
  .text-gray-400 {
    color: var(--color-gray-400);
  }
  .text-green-400 {
    color: var(--color-green-400);
  }
  .text-orange-400 {
    color: var(--color-orange-400);
  }
  .text-purple-400 {
    color: var(--color-purple-400);
  }
  .text-red-400 {
    color: var(--color-red-400);
  }
  .text-white {
    color: var(--color-white);
  }
  .text-yellow-400 {
    color: var(--color-yellow-400);
  }
  .capitalize {
    text-transform: capitalize;
  }
  .normal-case {
    text-transform: none;
  }
  .uppercase {
    text-transform: uppercase;
  }
  .italic {
    font-style: italic;
  }
  .tabular-nums {
    --tw-numeric-spacing: tabular-nums;
    font-variant-numeric: var(--tw-ordinal,) var(--tw-slashed-zero,) var(--tw-numeric-figure,) var(--tw-numeric-spacing,) var(--tw-numeric-fraction,);
  }
  .placeholder-\\[var\\(--color-ide-text-dim\\)\\] {
    &::placeholder {
      color: var(--color-ide-text-dim);
    }
  }
  .placeholder-\\[var\\(--color-ide-text-muted\\)\\] {
    &::placeholder {
      color: var(--color-ide-text-muted);
    }
  }
  .opacity-0 {
    opacity: 0%;
  }
  .opacity-40 {
    opacity: 40%;
  }
  .opacity-50 {
    opacity: 50%;
  }
  .opacity-60 {
    opacity: 60%;
  }
  .opacity-70 {
    opacity: 70%;
  }
  .opacity-80 {
    opacity: 80%;
  }
  .shadow-lg {
    --tw-shadow: 0 10px 15px -3px var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 4px 6px -4px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .shadow-xl {
    --tw-shadow: 0 20px 25px -5px var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 8px 10px -6px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .ring {
    --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  }
  .outline {
    outline-style: var(--tw-outline-style);
    outline-width: 1px;
  }
  .blur {
    --tw-blur: blur(8px);
    filter: var(--tw-blur,) var(--tw-brightness,) var(--tw-contrast,) var(--tw-grayscale,) var(--tw-hue-rotate,) var(--tw-invert,) var(--tw-saturate,) var(--tw-sepia,) var(--tw-drop-shadow,);
  }
  .\\!filter {
    filter: var(--tw-blur,) var(--tw-brightness,) var(--tw-contrast,) var(--tw-grayscale,) var(--tw-hue-rotate,) var(--tw-invert,) var(--tw-saturate,) var(--tw-sepia,) var(--tw-drop-shadow,) !important;
  }
  .filter {
    filter: var(--tw-blur,) var(--tw-brightness,) var(--tw-contrast,) var(--tw-grayscale,) var(--tw-hue-rotate,) var(--tw-invert,) var(--tw-saturate,) var(--tw-sepia,) var(--tw-drop-shadow,);
  }
  .transition {
    transition-property: color, background-color, border-color, outline-color, text-decoration-color, fill, stroke, --tw-gradient-from, --tw-gradient-via, --tw-gradient-to, opacity, box-shadow, transform, translate, scale, rotate, filter, -webkit-backdrop-filter, backdrop-filter, display, content-visibility, overlay, pointer-events;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-colors {
    transition-property: color, background-color, border-color, outline-color, text-decoration-color, fill, stroke, --tw-gradient-from, --tw-gradient-via, --tw-gradient-to;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-opacity {
    transition-property: opacity;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .outline-none {
    --tw-outline-style: none;
    outline-style: none;
  }
  .select-none {
    -webkit-user-select: none;
    user-select: none;
  }
  .select-text {
    -webkit-user-select: text;
    user-select: text;
  }
  .group-hover\\:opacity-100 {
    &:is(:where(.group):hover *) {
      @media (hover: hover) {
        opacity: 100%;
      }
    }
  }
  .first\\:border-t-0 {
    &:first-child {
      border-top-style: var(--tw-border-style);
      border-top-width: 0px;
    }
  }
  .last\\:border-b-0 {
    &:last-child {
      border-bottom-style: var(--tw-border-style);
      border-bottom-width: 0px;
    }
  }
  .hover\\:bg-\\[var\\(--color-ide-accent\\)\\] {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-ide-accent);
      }
    }
  }
  .hover\\:bg-\\[var\\(--color-ide-hover\\)\\] {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-ide-hover);
      }
    }
  }
  .hover\\:bg-\\[var\\(--color-ide-surface-hover\\)\\] {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-ide-surface-hover);
      }
    }
  }
  .hover\\:bg-\\[var\\(--color-ide-surface-selected\\)\\] {
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-ide-surface-selected);
      }
    }
  }
  .hover\\:bg-blue-500\\/20 {
    &:hover {
      @media (hover: hover) {
        background-color: color-mix(in srgb, oklch(62.3% 0.214 259.815) 20%, transparent);
        @supports (color: color-mix(in lab, red, red)) {
          background-color: color-mix(in oklab, var(--color-blue-500) 20%, transparent);
        }
      }
    }
  }
  .hover\\:bg-cyan-500\\/20 {
    &:hover {
      @media (hover: hover) {
        background-color: color-mix(in srgb, oklch(71.5% 0.143 215.221) 20%, transparent);
        @supports (color: color-mix(in lab, red, red)) {
          background-color: color-mix(in oklab, var(--color-cyan-500) 20%, transparent);
        }
      }
    }
  }
  .hover\\:bg-gray-500\\/20 {
    &:hover {
      @media (hover: hover) {
        background-color: color-mix(in srgb, oklch(55.1% 0.027 264.364) 20%, transparent);
        @supports (color: color-mix(in lab, red, red)) {
          background-color: color-mix(in oklab, var(--color-gray-500) 20%, transparent);
        }
      }
    }
  }
  .hover\\:bg-orange-500\\/20 {
    &:hover {
      @media (hover: hover) {
        background-color: color-mix(in srgb, oklch(70.5% 0.213 47.604) 20%, transparent);
        @supports (color: color-mix(in lab, red, red)) {
          background-color: color-mix(in oklab, var(--color-orange-500) 20%, transparent);
        }
      }
    }
  }
  .hover\\:bg-purple-500\\/20 {
    &:hover {
      @media (hover: hover) {
        background-color: color-mix(in srgb, oklch(62.7% 0.265 303.9) 20%, transparent);
        @supports (color: color-mix(in lab, red, red)) {
          background-color: color-mix(in oklab, var(--color-purple-500) 20%, transparent);
        }
      }
    }
  }
  .hover\\:bg-red-500\\/20 {
    &:hover {
      @media (hover: hover) {
        background-color: color-mix(in srgb, oklch(63.7% 0.237 25.331) 20%, transparent);
        @supports (color: color-mix(in lab, red, red)) {
          background-color: color-mix(in oklab, var(--color-red-500) 20%, transparent);
        }
      }
    }
  }
  .hover\\:bg-white\\/5 {
    &:hover {
      @media (hover: hover) {
        background-color: color-mix(in srgb, #fff 5%, transparent);
        @supports (color: color-mix(in lab, red, red)) {
          background-color: color-mix(in oklab, var(--color-white) 5%, transparent);
        }
      }
    }
  }
  .hover\\:bg-white\\/10 {
    &:hover {
      @media (hover: hover) {
        background-color: color-mix(in srgb, #fff 10%, transparent);
        @supports (color: color-mix(in lab, red, red)) {
          background-color: color-mix(in oklab, var(--color-white) 10%, transparent);
        }
      }
    }
  }
  .hover\\:bg-yellow-500\\/20 {
    &:hover {
      @media (hover: hover) {
        background-color: color-mix(in srgb, oklch(79.5% 0.184 86.047) 20%, transparent);
        @supports (color: color-mix(in lab, red, red)) {
          background-color: color-mix(in oklab, var(--color-yellow-500) 20%, transparent);
        }
      }
    }
  }
  .hover\\:text-\\[var\\(--color-ide-text\\)\\] {
    &:hover {
      @media (hover: hover) {
        color: var(--color-ide-text);
      }
    }
  }
  .hover\\:text-red-300 {
    &:hover {
      @media (hover: hover) {
        color: var(--color-red-300);
      }
    }
  }
  .hover\\:underline {
    &:hover {
      @media (hover: hover) {
        text-decoration-line: underline;
      }
    }
  }
  .hover\\:opacity-60 {
    &:hover {
      @media (hover: hover) {
        opacity: 60%;
      }
    }
  }
  .hover\\:opacity-70 {
    &:hover {
      @media (hover: hover) {
        opacity: 70%;
      }
    }
  }
  .hover\\:opacity-80 {
    &:hover {
      @media (hover: hover) {
        opacity: 80%;
      }
    }
  }
  .focus\\:border-\\[var\\(--color-ide-accent\\)\\] {
    &:focus {
      border-color: var(--color-ide-accent);
    }
  }
  .focus\\:outline-none {
    &:focus {
      --tw-outline-style: none;
      outline-style: none;
    }
  }
  .disabled\\:cursor-not-allowed {
    &:disabled {
      cursor: not-allowed;
    }
  }
  .disabled\\:opacity-30 {
    &:disabled {
      opacity: 30%;
    }
  }
  .disabled\\:opacity-40 {
    &:disabled {
      opacity: 40%;
    }
  }
  .disabled\\:opacity-50 {
    &:disabled {
      opacity: 50%;
    }
  }
}
@font-face {
  font-family: 'Inconsolata';
  font-style: normal;
  font-display: swap;
  font-weight: 400;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2'), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff');
  unicode-range: U+0102-0103,U+0110-0111,U+0128-0129,U+0168-0169,U+01A0-01A1,U+01AF-01B0,U+0300-0301,U+0303-0304,U+0308-0309,U+0323,U+0329,U+1EA0-1EF9,U+20AB;
}
@font-face {
  font-family: 'Inconsolata';
  font-style: normal;
  font-display: swap;
  font-weight: 400;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff2'), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('woff');
  unicode-range: U+0100-02BA,U+02BD-02C5,U+02C7-02CC,U+02CE-02D7,U+02DD-02FF,U+0304,U+0308,U+0329,U+1D00-1DBF,U+1E00-1E9F,U+1EF2-1EFF,U+2020,U+20A0-20AB,U+20AD-20C0,U+2113,U+2C60-2C7F,U+A720-A7FF;
}
@font-face {
  font-family: 'Inconsolata';
  font-style: normal;
  font-display: swap;
  font-weight: 400;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('woff2'), url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('woff');
  unicode-range: U+0000-00FF,U+0131,U+0152-0153,U+02BB-02BC,U+02C6,U+02DA,U+02DC,U+0304,U+0308,U+0329,U+2000-206F,U+20AC,U+2122,U+2191,U+2193,U+2212,U+2215,U+FEFF,U+FFFD;
}
@font-face {
  font-family: 'Inconsolata';
  font-style: normal;
  font-display: swap;
  font-weight: 500;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format('woff2'), url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format('woff');
  unicode-range: U+0102-0103,U+0110-0111,U+0128-0129,U+0168-0169,U+01A0-01A1,U+01AF-01B0,U+0300-0301,U+0303-0304,U+0308-0309,U+0323,U+0329,U+1EA0-1EF9,U+20AB;
}
@font-face {
  font-family: 'Inconsolata';
  font-style: normal;
  font-display: swap;
  font-weight: 500;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format('woff2'), url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format('woff');
  unicode-range: U+0100-02BA,U+02BD-02C5,U+02C7-02CC,U+02CE-02D7,U+02DD-02FF,U+0304,U+0308,U+0329,U+1D00-1DBF,U+1E00-1E9F,U+1EF2-1EFF,U+2020,U+20A0-20AB,U+20AD-20C0,U+2113,U+2C60-2C7F,U+A720-A7FF;
}
@font-face {
  font-family: 'Inconsolata';
  font-style: normal;
  font-display: swap;
  font-weight: 500;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format('woff2'), url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format('woff');
  unicode-range: U+0000-00FF,U+0131,U+0152-0153,U+02BB-02BC,U+02C6,U+02DA,U+02DC,U+0304,U+0308,U+0329,U+2000-206F,U+20AC,U+2122,U+2191,U+2193,U+2212,U+2215,U+FEFF,U+FFFD;
}
:root {
  --color-ide-accent: #007acc;
  --color-ide-accent-hover: #1a8ad4;
  --color-ide-error: #f14c4c;
  --color-ide-warn: #d9a441;
  --color-ide-agent-working: #0a84ff;
  --color-ide-agent-working-strong: #4aa8ff;
  --color-ide-agent-done: #3fb950;
  --color-ide-agent-on-strong: #ffffff;
}
:root[data-theme="dark"] {
  --color-ide-bg: #1e1e1e;
  --color-ide-surface: #252526;
  --color-ide-surface-2: #2d2d2d;
  --color-ide-border: #3c3c3c;
  --color-ide-text: #cccccc;
  --color-ide-text-muted: #888888;
  --color-ide-text-dim: #555555;
  --color-ide-activity: #333333;
  --color-ide-tab-active: #1e1e1e;
  --color-ide-tab-inactive: #2d2d30;
  --color-ide-hover-overlay: rgba(255, 255, 255, 0.07);
  --color-ide-hover-overlay-strong: rgba(255, 255, 255, 0.1);
  --color-ide-shadow: rgba(0, 0, 0, 0.5);
  --color-ide-shadow-light: rgba(0, 0, 0, 0.3);
  --color-ide-backdrop: rgba(0, 0, 0, 0.25);
  --color-ide-selection-bg: #007acc;
  --color-ide-selection-text: #ffffff;
  --color-ide-agent-working-soft: rgba(10, 132, 255, 0.28);
}
:root[data-theme="light"] {
  --color-ide-bg: #e8e8e8;
  --color-ide-surface: #f3f3f3;
  --color-ide-surface-2: #e8e8e8;
  --color-ide-border: #d4d4d4;
  --color-ide-text: #333333;
  --color-ide-text-muted: #666666;
  --color-ide-text-dim: #999999;
  --color-ide-activity: #e0e0e0;
  --color-ide-tab-active: #ffffff;
  --color-ide-tab-inactive: #ececec;
  --color-ide-hover-overlay: rgba(0, 0, 0, 0.05);
  --color-ide-hover-overlay-strong: rgba(0, 0, 0, 0.08);
  --color-ide-shadow: rgba(0, 0, 0, 0.15);
  --color-ide-shadow-light: rgba(0, 0, 0, 0.12);
  --color-ide-backdrop: rgba(0, 0, 0, 0.15);
  --color-ide-selection-bg: #cce6ff;
  --color-ide-selection-text: var(--color-ide-text);
  --color-ide-agent-working-soft: rgba(10, 132, 255, 0.2);
}
html,
body {
  font-family: "Inconsolata", ui-monospace, "Cascadia Code", monospace;
  font-size: 13px;
  background-color: var(--color-ide-bg);
  color: var(--color-ide-text);
}
.ide-frame {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 35px 1fr;
  grid-template-areas: "titlebar"
    "dock";
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background-color: var(--color-ide-bg);
  color: var(--color-ide-text);
  font-family: "Inconsolata", ui-monospace, "Cascadia Code", monospace;
  font-size: 13px;
}
.ide-title-bar {
  grid-area: titlebar;
  background-color: var(--color-ide-surface);
  border-bottom: 1px solid var(--color-ide-border);
  display: flex;
  align-items: center;
  padding: 0 6px;
  gap: 4px;
  user-select: none;
  font-size: 12px;
}
.ide-title-left,
.ide-title-right {
  display: flex;
  align-items: center;
  gap: 2px;
  flex-shrink: 0;
}
.ide-title-logo {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  color: var(--color-ide-accent);
  font-size: 18px;
  font-weight: 600;
  line-height: 1;
  flex-shrink: 0;
  font-style: italic;
  cursor: default;
  user-select: none;
}
.ide-title-command-center {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  max-width: 420px;
  margin: 0 auto;
  height: 24px;
  padding: 0 12px;
  border-radius: 6px;
  background-color: var(--color-ide-surface-2);
  border: 1px solid var(--color-ide-border);
  color: var(--color-ide-text-muted);
  font-size: 12px;
  cursor: pointer;
  transition: border-color 0.1s, color 0.1s, background-color 0.1s;
}
.ide-title-command-center:hover {
  border-color: var(--color-ide-text-dim);
  background-color: var(--color-ide-hover-overlay-strong);
  color: var(--color-ide-text);
}
.ide-title-command-icon {
  opacity: 0.6;
  flex-shrink: 0;
}
.ide-title-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 24px;
  border: none;
  background: none;
  color: var(--color-ide-text-muted);
  cursor: pointer;
  border-radius: 4px;
  padding: 0;
  transition: background-color 0.1s, color 0.1s;
}
.ide-title-btn:hover:not(:disabled) {
  background-color: var(--color-ide-hover-overlay);
  color: var(--color-ide-text);
}
.ide-title-btn:disabled {
  opacity: 0.3;
  cursor: default;
}
.ide-title-btn.ide-title-btn-active {
  color: var(--color-ide-text);
  background-color: var(--color-ide-hover-overlay);
}
.ide-network-status {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 22px;
  padding: 0 10px;
  margin-left: 4px;
  border-radius: 11px;
  background-color: var(--color-ide-surface-2);
  border: 1px solid var(--color-ide-border);
  color: var(--color-ide-text-muted);
  font-size: 11px;
  line-height: 1;
  user-select: none;
  cursor: default;
}
.ide-network-status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
  background-color: var(--color-ide-text-muted);
}
.ide-network-status[data-connected="true"] .ide-network-status-dot {
  background-color: #3fb950;
  box-shadow: 0 0 4px rgba(63, 185, 80, 0.6);
}
.ide-network-status[data-connected="false"] .ide-network-status-dot {
  background-color: var(--color-ide-error);
  box-shadow: 0 0 4px rgba(241, 76, 76, 0.6);
}
.ide-network-status[data-connected="false"] .ide-network-status-label {
  color: var(--color-ide-error);
}
.ide-activity-bar {
  grid-area: activity;
  background-color: var(--color-ide-activity);
  border-right: 1px solid var(--color-ide-border);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 4px 0;
}
.ide-activity-top,
.ide-activity-bottom {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.ide-activity-bottom {
  border-top: 1px solid var(--color-ide-border);
  padding-top: 4px;
  margin-top: 4px;
}
.ide-activity-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 40px;
  cursor: pointer;
  color: var(--color-ide-text-muted);
  position: relative;
  transition: color 0.1s;
}
.ide-activity-icon:hover {
  color: var(--color-ide-text);
}
.ide-activity-icon-active {
  color: var(--color-ide-text);
  border-left: 2px solid var(--color-ide-accent);
}
.ide-panel-header-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border: none;
  background: none;
  color: var(--color-ide-text-dim);
  cursor: pointer;
  border-radius: 3px;
  padding: 0;
  flex-shrink: 0;
  transition: background-color 0.1s, color 0.1s;
}
.ide-panel-header-btn:hover {
  background-color: var(--color-ide-hover-overlay);
  color: var(--color-ide-text-muted);
}
@keyframes ide-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.ide-spin svg {
  animation: ide-spin 0.8s linear infinite;
}
@keyframes ide-fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes ide-slide-open {
  from {
    grid-template-rows: 0fr;
  }
  to {
    grid-template-rows: 1fr;
  }
}
.ide-fade-in {
  display: grid;
  animation: ide-fade-in 0.2s ease-out, ide-slide-open 0.2s ease-out;
}
.ide-fade-in > * {
  overflow: hidden;
}
.ide-dock-area {
  grid-area: dock;
  position: relative;
  overflow: hidden;
}
.ide-status-bar {
  grid-area: status;
  background-color: var(--color-ide-accent);
  color: #ffffff;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 0 12px;
  font-size: 11px;
  font-family: "Inconsolata", ui-monospace, monospace;
  user-select: none;
}
.ide-status-item {
  opacity: 0.9;
  white-space: nowrap;
}
.ide-status-accent {
  font-weight: 600;
}
.ide-editor-pane {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  background-color: var(--editor-canvas-bg, var(--color-ide-bg));
}
.ide-editor-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  color: var(--color-ide-text-dim);
  font-size: 13px;
}
.ide-editor-tab-header {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 0 8px;
  height: 100%;
  font-size: 13px;
  white-space: nowrap;
  user-select: none;
}
.ide-editor-tab-close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border: none;
  background: none;
  color: inherit;
  cursor: pointer;
  border-radius: 3px;
  padding: 0;
  opacity: 0;
}
.dv-tab:hover .ide-editor-tab-close {
  opacity: 0.7;
}
.ide-editor-tab-close:hover {
  opacity: 1 !important;
  background-color: var(--color-ide-hover-overlay-strong);
}
.dockview-theme-abyss {
  --dv-color-abyss-dark: var(--color-ide-bg);
  --dv-color-abyss: var(--color-ide-surface);
  --dv-color-abyss-light: var(--color-ide-surface);
  --dv-color-abyss-lighter: var(--color-ide-border);
  --dv-color-abyss-accent: var(--color-ide-accent);
  --dv-color-abyss-primary-text: var(--color-ide-text);
  --dv-color-abyss-secondary-text: var(--color-ide-text-muted);
  --dv-group-view-background-color: var(--color-ide-bg);
  --dv-tabs-and-actions-container-background-color: var(
    --color-ide-tab-inactive
  );
  --dv-tabs-and-actions-container-height: 35px;
  --dv-tabs-and-actions-container-font-size: 12px;
  --dv-activegroup-visiblepanel-tab-background-color: var(
    --color-ide-tab-active
  );
  --dv-activegroup-hiddenpanel-tab-background-color: var(
    --color-ide-tab-inactive
  );
  --dv-inactivegroup-visiblepanel-tab-background-color: var(
    --color-ide-surface
  );
  --dv-inactivegroup-hiddenpanel-tab-background-color: var(
    --color-ide-surface-2
  );
  --dv-activegroup-visiblepanel-tab-color: var(--color-ide-text);
  --dv-activegroup-hiddenpanel-tab-color: var(--color-ide-text-muted);
  --dv-inactivegroup-visiblepanel-tab-color: var(--color-ide-text-muted);
  --dv-inactivegroup-hiddenpanel-tab-color: var(--color-ide-text-dim);
  --dv-tab-divider-color: var(--color-ide-border);
  --dv-separator-border: var(--color-ide-border);
  --dv-sash-color: transparent;
  --dv-active-sash-color: var(--color-ide-accent);
  font-family: "Inconsolata", ui-monospace, monospace;
}
.dockview-theme-abyss .dv-tab,
.dockview-theme-abyss .dv-tabs-and-actions-container {
  font-family: "Inconsolata", ui-monospace, monospace;
}
.dockview-theme-abyss .dv-groupview.dv-active-group .dv-tab.dv-active-tab {
  border-top: 2px solid var(--color-ide-accent);
}
.dockview-theme-abyss .dv-groupview.dv-inactive-group .dv-tab.dv-active-tab {
  border-top: 2px solid var(--color-ide-text-dim);
}
.dockview-theme-abyss .dv-sash:hover {
  background-color: var(--color-ide-accent);
  opacity: 0.6;
}
.dockview-theme-abyss .dv-tab .dv-default-tab-action {
  display: none;
}
.dockview-theme-abyss .dv-tab:has(.ide-editor-area-marker) {
  display: none;
}
.dockview-theme-abyss .dv-tab:has(.ide-sidebar-placeholder-marker) {
  display: none;
}
.ide-sidebar-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: var(--color-ide-text-dim);
  font-size: 11px;
  user-select: none;
}
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
::-webkit-scrollbar-track {
  background: transparent;
}
::-webkit-scrollbar-thumb {
  background-color: var(--color-ide-border);
  border-radius: 3px;
}
::-webkit-scrollbar-thumb:hover {
  background-color: var(--color-ide-text-dim);
}
.command-palette-backdrop {
  position: fixed;
  inset: 0;
  z-index: 50;
  background-color: var(--color-ide-backdrop);
}
.command-palette {
  position: absolute;
  top: 6px;
  left: 50%;
  transform: translateX(-50%);
  width: 480px;
  max-height: 340px;
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  border: 1px solid var(--color-ide-border);
  background-color: var(--color-ide-surface);
  box-shadow: 0 8px 30px var(--color-ide-shadow);
  overflow: hidden;
  font-family: "Inconsolata", ui-monospace, monospace;
}
.command-palette-input {
  width: 100%;
  padding: 10px 14px;
  border: none;
  border-bottom: 1px solid var(--color-ide-border);
  background-color: var(--color-ide-surface);
  color: var(--color-ide-text);
  font-family: inherit;
  font-size: 13px;
  outline: none;
}
.command-palette-input::placeholder {
  color: var(--color-ide-text-dim);
}
.command-palette-prompt-label {
  padding: 6px 14px;
  font-size: 11px;
  color: var(--color-ide-text-muted);
  border-bottom: 1px solid var(--color-ide-border);
  background-color: var(--color-ide-surface-2);
}
.command-palette-list {
  overflow-y: auto;
  flex: 1;
  min-height: 0;
}
.command-palette-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 14px;
  cursor: pointer;
  font-size: 13px;
  color: var(--color-ide-text);
  transition: background-color 0.05s;
}
.command-palette-row:hover {
  background-color: var(--color-ide-surface-2);
}
.command-palette-row-selected {
  background-color: rgba(0, 122, 204, 0.3);
}
.command-palette-row-selected:hover {
  background-color: rgba(0, 122, 204, 0.35);
}
.command-palette-row-label {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.command-palette-row-category {
  color: var(--color-ide-text-muted);
}
.command-palette-keybinding {
  flex-shrink: 0;
  margin-left: 16px;
  padding: 1px 6px;
  border-radius: 3px;
  border: 1px solid var(--color-ide-border);
  background-color: var(--color-ide-surface-2);
  color: var(--color-ide-text-muted);
  font-size: 11px;
}
.command-palette-empty {
  padding: 12px 14px;
  color: var(--color-ide-text-dim);
  font-size: 13px;
  text-align: center;
}
.command-palette-divider {
  padding: 4px 14px;
  margin-top: 4px;
  border-top: 1px solid var(--color-ide-border);
  color: var(--color-ide-text-dim);
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  user-select: none;
}
.command-palette-row-disabled {
  cursor: default;
  opacity: 0.45;
}
.command-palette-row-disabled:hover {
  background-color: transparent;
}
.add-instance-dialog {
  max-height: 440px;
}
.add-instance-row {
  padding: 6px 14px;
  cursor: pointer;
  transition: background-color 0.05s;
}
.add-instance-row:hover {
  background-color: var(--color-ide-surface-2);
}
.add-instance-row-selected {
  background-color: rgba(0, 122, 204, 0.3);
}
.add-instance-row-selected:hover {
  background-color: rgba(0, 122, 204, 0.35);
}
.add-instance-row-name {
  font-size: 13px;
  color: var(--color-ide-text);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.add-instance-row-description {
  font-size: 11px;
  color: var(--color-ide-text-muted);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-top: 1px;
}
.add-instance-section-header {
  padding: 6px 14px 3px;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--color-ide-text-dim);
  user-select: none;
}
.add-instance-params {
  padding: 8px 14px;
  overflow-y: auto;
  flex: 1;
  min-height: 0;
}
.add-instance-param-field {
  margin-bottom: 8px;
}
.add-instance-param-label {
  display: block;
  font-size: 12px;
  color: var(--color-ide-text);
  margin-bottom: 3px;
}
.add-instance-param-hint {
  color: var(--color-ide-text-dim);
  font-size: 11px;
}
.add-instance-param-input {
  width: 100%;
  padding: 5px 8px;
  border: 1px solid var(--color-ide-border);
  border-radius: 3px;
  background-color: var(--color-ide-bg);
  color: var(--color-ide-text);
  font-family: "Inconsolata", ui-monospace, monospace;
  font-size: 12px;
  outline: none;
  box-sizing: border-box;
}
.add-instance-param-input:focus {
  border-color: var(--color-ide-accent);
}
.add-instance-param-input-error {
  border-color: var(--color-ide-error);
}
.add-instance-param-input-error:focus {
  border-color: var(--color-ide-error);
}
.add-instance-param-input-shake {
  animation: param-shake 0.4s ease-in-out;
}
@keyframes param-shake {
  0%,
  100% {
    transform: translateX(0);
  }
  20%,
  60% {
    transform: translateX(-4px);
  }
  40%,
  80% {
    transform: translateX(4px);
  }
}
.add-instance-param-constraint {
  display: block;
  font-size: 11px;
  color: var(--color-ide-text-dim);
  font-style: italic;
  margin-top: 2px;
}
.add-instance-param-error {
  display: block;
  font-size: 11px;
  color: var(--color-ide-error);
  margin-top: 2px;
}
.add-instance-shape-field {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 0 14px 8px;
  font-size: 12px;
  color: var(--color-ide-text);
}
.add-instance-shape-field input {
  margin: 0;
}
.add-instance-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 14px;
  border-top: 1px solid var(--color-ide-border);
}
.add-instance-hint {
  font-size: 11px;
  color: var(--color-ide-text-dim);
}
.add-instance-btn {
  padding: 4px 12px;
  border: 1px solid var(--color-ide-border);
  border-radius: 3px;
  background-color: var(--color-ide-accent);
  color: #fff;
  font-size: 12px;
  font-family: inherit;
  cursor: pointer;
}
.add-instance-btn:hover {
  opacity: 0.9;
}
.add-instance-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.ide-dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  min-width: 180px;
  background-color: var(--color-ide-surface);
  border: 1px solid var(--color-ide-border);
  border-radius: 4px;
  box-shadow: 0 4px 12px var(--color-ide-shadow-light);
  z-index: 1000;
  padding: 4px 0;
}
.ide-dropdown-item {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 6px 12px;
  border: none;
  background: none;
  color: var(--color-ide-text);
  font-size: 12px;
  font-family: inherit;
  cursor: pointer;
  text-align: left;
}
.ide-dropdown-item:hover {
  background-color: var(--color-ide-accent);
  color: #fff;
}
.ide-dropdown-divider {
  height: 1px;
  background-color: var(--color-ide-border);
  margin: 4px 0;
}
.ide-collapsed-tab {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 100%;
  cursor: pointer;
  user-select: none;
  transition: background-color 0.1s;
}
.ide-collapsed-tab:hover {
  background-color: var(--color-ide-hover-overlay);
}
.ide-collapsed-tab-letter {
  font-size: 11px;
  font-weight: 600;
  color: var(--color-ide-text-muted);
  text-transform: uppercase;
}
.dockview-theme-abyss .dv-tab:has(.ide-collapsed-tab) {
  flex: 0 0 auto !important;
  min-width: 0 !important;
  width: auto !important;
  padding: 0 !important;
}
.ide-panel-dropdown-menu {
  min-width: 140px;
  background-color: var(--color-ide-surface);
  border: 1px solid var(--color-ide-border);
  border-radius: 4px;
  box-shadow: 0 4px 12px var(--color-ide-shadow-light);
  z-index: 10000;
  padding: 4px 0;
}
@property --tw-translate-x {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-translate-y {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-translate-z {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-rotate-x {
  syntax: "*";
  inherits: false;
}
@property --tw-rotate-y {
  syntax: "*";
  inherits: false;
}
@property --tw-rotate-z {
  syntax: "*";
  inherits: false;
}
@property --tw-skew-x {
  syntax: "*";
  inherits: false;
}
@property --tw-skew-y {
  syntax: "*";
  inherits: false;
}
@property --tw-space-y-reverse {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-border-style {
  syntax: "*";
  inherits: false;
  initial-value: solid;
}
@property --tw-leading {
  syntax: "*";
  inherits: false;
}
@property --tw-font-weight {
  syntax: "*";
  inherits: false;
}
@property --tw-tracking {
  syntax: "*";
  inherits: false;
}
@property --tw-ordinal {
  syntax: "*";
  inherits: false;
}
@property --tw-slashed-zero {
  syntax: "*";
  inherits: false;
}
@property --tw-numeric-figure {
  syntax: "*";
  inherits: false;
}
@property --tw-numeric-spacing {
  syntax: "*";
  inherits: false;
}
@property --tw-numeric-fraction {
  syntax: "*";
  inherits: false;
}
@property --tw-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-inset-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-inset-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-inset-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-ring-color {
  syntax: "*";
  inherits: false;
}
@property --tw-ring-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-inset-ring-color {
  syntax: "*";
  inherits: false;
}
@property --tw-inset-ring-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-ring-inset {
  syntax: "*";
  inherits: false;
}
@property --tw-ring-offset-width {
  syntax: "<length>";
  inherits: false;
  initial-value: 0px;
}
@property --tw-ring-offset-color {
  syntax: "*";
  inherits: false;
  initial-value: #fff;
}
@property --tw-ring-offset-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-outline-style {
  syntax: "*";
  inherits: false;
  initial-value: solid;
}
@property --tw-blur {
  syntax: "*";
  inherits: false;
}
@property --tw-brightness {
  syntax: "*";
  inherits: false;
}
@property --tw-contrast {
  syntax: "*";
  inherits: false;
}
@property --tw-grayscale {
  syntax: "*";
  inherits: false;
}
@property --tw-hue-rotate {
  syntax: "*";
  inherits: false;
}
@property --tw-invert {
  syntax: "*";
  inherits: false;
}
@property --tw-opacity {
  syntax: "*";
  inherits: false;
}
@property --tw-saturate {
  syntax: "*";
  inherits: false;
}
@property --tw-sepia {
  syntax: "*";
  inherits: false;
}
@property --tw-drop-shadow {
  syntax: "*";
  inherits: false;
}
@property --tw-drop-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-drop-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-drop-shadow-size {
  syntax: "*";
  inherits: false;
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
@layer properties {
  @supports ((-webkit-hyphens: none) and (not (margin-trim: inline))) or ((-moz-orient: inline) and (not (color:rgb(from red r g b)))) {
    *, ::before, ::after, ::backdrop {
      --tw-translate-x: 0;
      --tw-translate-y: 0;
      --tw-translate-z: 0;
      --tw-rotate-x: initial;
      --tw-rotate-y: initial;
      --tw-rotate-z: initial;
      --tw-skew-x: initial;
      --tw-skew-y: initial;
      --tw-space-y-reverse: 0;
      --tw-border-style: solid;
      --tw-leading: initial;
      --tw-font-weight: initial;
      --tw-tracking: initial;
      --tw-ordinal: initial;
      --tw-slashed-zero: initial;
      --tw-numeric-figure: initial;
      --tw-numeric-spacing: initial;
      --tw-numeric-fraction: initial;
      --tw-shadow: 0 0 #0000;
      --tw-shadow-color: initial;
      --tw-shadow-alpha: 100%;
      --tw-inset-shadow: 0 0 #0000;
      --tw-inset-shadow-color: initial;
      --tw-inset-shadow-alpha: 100%;
      --tw-ring-color: initial;
      --tw-ring-shadow: 0 0 #0000;
      --tw-inset-ring-color: initial;
      --tw-inset-ring-shadow: 0 0 #0000;
      --tw-ring-inset: initial;
      --tw-ring-offset-width: 0px;
      --tw-ring-offset-color: #fff;
      --tw-ring-offset-shadow: 0 0 #0000;
      --tw-outline-style: solid;
      --tw-blur: initial;
      --tw-brightness: initial;
      --tw-contrast: initial;
      --tw-grayscale: initial;
      --tw-hue-rotate: initial;
      --tw-invert: initial;
      --tw-opacity: initial;
      --tw-saturate: initial;
      --tw-sepia: initial;
      --tw-drop-shadow: initial;
      --tw-drop-shadow-color: initial;
      --tw-drop-shadow-alpha: 100%;
      --tw-drop-shadow-size: initial;
    }
  }
}
`, "",{"version":3,"sources":["<no source>","webpack://./../../node_modules/tailwindcss/index.css","webpack://./../../node_modules/@fontsource/inconsolata/400.css","webpack://./../../node_modules/@fontsource/inconsolata/500.css","webpack://./src/ide.css"],"names":[],"mappings":"AAAA,iEAAA;AC86BE,iBAAmB;AA96BrB,yCAAyC;AAEzC;EACE;IACE;6DAEyD;IAEzD;8BAE0B;IAK1B,0CAA0C;IAC1C,0CAA0C;IAC1C,0CAA0C;IAW1C,2CAA2C;IAC3C,6CAA6C;IAW7C,4CAA4C;IAC5C,2CAA2C;IAW3C,6CAA6C;IAC7C,6CAA6C;IAuB7C,6CAA6C;IAC7C,6CAA6C;IAmC7C,2CAA2C;IAC3C,4CAA4C;IAuB5C,4CAA4C;IAC5C,4CAA4C;IAmC5C,8CAA8C;IAC9C,4CAA4C;IA2D5C,4CAA4C;IAC5C,4CAA4C;IA2F5C,mBAAmB;IACnB,mBAAmB;IAEnB,kBAAkB;IAYlB,qBAAqB;IAUrB,kBAAkB;IAClB,sCAAsC;IACtC,mBAAmB;IACnB,0CAA0C;IA2B1C,yBAAyB;IACzB,yBAAyB;IACzB,2BAA2B;IAC3B,uBAAuB;IAMvB,sBAAsB;IACtB,wBAAwB;IACxB,wBAAwB;IACxB,wBAAwB;IAGxB,qBAAqB;IAErB,wBAAwB;IAKxB,qBAAqB;IACrB,mBAAmB;IA4CnB,uCAAuC;IAsDvC,oCAAoC;IACpC,kEAAkE;IAClE,uCAAoD;IASpD,4CAAyD;EA5f5C;AADJ;AAmhBb;EAOE;IAKE,sBAAsB;IACtB,SAAS;IACT,UAAU;IACV,eAAe;EAJM;EAiBvB;IAEE,gBAAgB;IAChB,8BAA8B;IAC9B,WAAW;IACX,2JASC;IACD,mEAGC;IACD,uEAGC;IACD,wCAAwC;EAtBpC;EA+BN;IACE,SAAS;IACT,cAAc;IACd,qBAAqB;EAHpB;EAUH;IACE,yCAAyC;IACzC,iCAAiC;EAFf;EASpB;IAME,kBAAkB;IAClB,oBAAoB;EAFnB;EASH;IACE,cAAc;IACd,gCAAgC;IAChC,wBAAwB;EAHxB;EAUF;IAEE,mBAAmB;EADd;EAWP;IAIE,gJAUC;IACD,wEAGC;IACD,4EAGC;IACD,cAAc;EApBZ;EA2BJ;IACE,cAAc;EADV;EAQN;IAEE,cAAc;IACd,cAAc;IACd,kBAAkB;IAClB,wBAAwB;EAJtB;EAOJ;IACE,eAAe;EADb;EAIJ;IACE,WAAW;EADT;EAUJ;IACE,cAAc;IACd,qBAAqB;IACrB,yBAAyB;EAHrB;EAUN;IACE,aAAa;EADC;EAQhB;IACE,wBAAwB;EADjB;EAQT;IACE,kBAAkB;EADZ;EAQR;IAGE,gBAAgB;EADb;EAUL;IAQE,cAAc;IACd,sBAAsB;EAFjB;EASP;IAEE,eAAe;IACf,YAAY;EAFR;EAYN;IAME,aAAa;IACb,8BAA8B;IAC9B,gCAAgC;IAChC,uBAAuB;IACvB,cAAc;IACd,gBAAgB;IAChB,6BAA6B;IAC7B,UAAU;EARW;EAevB;IACE,mBAAmB;EAD0B;EAQ/C;IACE,0BAA0B;EAD0B;EAQtD;IACE,sBAAsB;EADD;EAQvB;IACE,UAAU;EADE;EASd;IAEE;MACE,mBAAyD;MAAzD;QAAA,yDAAyD;MAAA;IAD7C;EADiC;EAUjD;IACE,gBAAgB;EADT;EAQT;IACE,wBAAwB;EADE;EAS5B;IACE,eAAe;IACf,mBAAmB;EAFS;EAS9B;IACE,oBAAoB;EADE;EAQxB;IACE,UAAU;EAD2B;EAIvC;IASE,gBAAgB;EADqB;EAQvC;IACE,cAAc;EADoB;EAQpC;IACE,gBAAgB;EADD;EAQjB;IAGE,kBAAkB;EADG;EAQvB;IAEE,YAAY;EADc;EAQ5B;IACE,wBAAwB;EADmB;AAnZnC;AAwZZ;EACE;IAAA,oBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,WAAmB;IAAnB;MAAA,gBAAmB;IAAA;IAAnB;MAAA,gBAAmB;IAAA;IAAnB;MAAA,gBAAmB;IAAA;IAAnB;MAAA,gBAAmB;IAAA;IAAnB;MAAA,gBAAmB;IAAA;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,OAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,+CAAmB;IAAnB,sDAAmB;EAAA;EAAnB;IAAA,0GAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA;MAAA,uBAAmB;MAAnB,8EAAmB;MAAnB,sFAAmB;IAAA;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,gBAAmB;IAAnB,uBAAmB;IAAnB,mBAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,wCAAmB;IAAnB,qBAAmB;EAAA;EAAnB;IAAA,2CAAmB;IAAnB,wBAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,sBAAmB;EAAA;EAAnB;IAAA,uBAAmB;IAAnB,kBAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,uDAAmB;IAAnB;MAAA,sEAAmB;IAAA;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,6CAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,4CAAmB;EAAA;EAAnB;IAAA,gDAAmB;EAAA;EAAnB;IAAA,gDAAmB;IAAnB;MAAA,sFAAmB;IAAA;EAAA;EAAnB;IAAA,+EAAmB;IAAnB;MAAA,8EAAmB;IAAA;EAAA;EAAnB;IAAA,2DAAmB;IAAnB;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,iFAAmB;IAAnB;MAAA,6EAAmB;IAAA;EAAA;EAAnB;IAAA,iFAAmB;IAAnB;MAAA,6EAAmB;IAAA;EAAA;EAAnB;IAAA,iFAAmB;IAAnB;MAAA,6EAAmB;IAAA;EAAA;EAAnB;IAAA,iFAAmB;IAAnB;MAAA,6EAAmB;IAAA;EAAA;EAAnB;IAAA,iFAAmB;IAAnB;MAAA,6EAAmB;IAAA;EAAA;EAAnB;IAAA,iFAAmB;IAAnB;MAAA,6EAAmB;IAAA;EAAA;EAAnB;IAAA,iFAAmB;IAAnB;MAAA,8EAAmB;IAAA;EAAA;EAAnB;IAAA,gFAAmB;IAAnB;MAAA,+EAAmB;IAAA;EAAA;EAAnB;IAAA,gFAAmB;IAAnB;MAAA,+EAAmB;IAAA;EAAA;EAAnB;IAAA,+EAAmB;IAAnB;MAAA,+EAAmB;IAAA;EAAA;EAAnB;IAAA,+EAAmB;IAAnB;MAAA,+EAAmB;IAAA;EAAA;EAAnB;IAAA,gFAAmB;IAAnB;MAAA,4EAAmB;IAAA;EAAA;EAAnB;IAAA,gFAAmB;IAAnB;MAAA,4EAAmB;IAAA;EAAA;EAAnB;IAAA,gFAAmB;IAAnB;MAAA,4EAAmB;IAAA;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,gFAAmB;IAAnB;MAAA,+EAAmB;IAAA;EAAA;EAAnB;IAAA,gFAAmB;IAAnB;MAAA,+EAAmB;IAAA;EAAA;EAAnB;IAAA,gFAAmB;IAAnB;MAAA,+EAAmB;IAAA;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,mCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,0CAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,2DAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,2DAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,mCAAmB;EAAA;EAAnB;IAAA,iCAAmB;IAAnB,gCAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,oCAAmB;EAAA;EAAnB;IAAA,2CAAmB;IAAnB,sCAAmB;EAAA;EAAnB;IAAA,2CAAmB;IAAnB,sCAAmB;EAAA;EAAnB;IAAA,6CAAmB;IAAnB,wCAAmB;EAAA;EAAnB;IAAA,qCAAmB;IAAnB,sCAAmB;EAAA;EAAnB;IAAA,mCAAmB;IAAnB,oCAAmB;EAAA;EAAnB;IAAA,oCAAmB;IAAnB,qCAAmB;EAAA;EAAnB;IAAA,qCAAmB;IAAnB,sCAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,4BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,2BAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,0BAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,kCAAmB;IAAnB,iJAAmB;EAAA;EAAnB;IAAA;MAAA,gCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,kCAAmB;IAAA;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,YAAmB;EAAA;EAAnB;IAAA,+HAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,gIAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,wHAAmB;IAAnB,sIAAmB;EAAA;EAAnB;IAAA,sCAAmB;IAAnB,kBAAmB;EAAA;EAAnB;IAAA,oBAAmB;IAAnB,0LAAmB;EAAA;EAAnB;IAAA,qMAAmB;EAAA;EAAnB;IAAA,0LAAmB;EAAA;EAAnB;IAAA,yUAAmB;IAAnB,qFAAmB;IAAnB,2EAAmB;EAAA;EAAnB;IAAA,uKAAmB;IAAnB,qFAAmB;IAAnB,2EAAmB;EAAA;EAAnB;IAAA,4BAAmB;IAAnB,qFAAmB;IAAnB,2EAAmB;EAAA;EAAnB;IAAA,wBAAmB;IAAnB,mBAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,iBAAmB;EAAA;EAAnB;IAAA;MAAA;QAAA,aAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,wCAAmB;MAAnB,qBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,2CAAmB;MAAnB,wBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,yCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,wCAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,gDAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,mDAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,iFAAmB;QAAnB;UAAA,6EAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,iFAAmB;QAAnB;UAAA,6EAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,iFAAmB;QAAnB;UAAA,6EAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,gFAAmB;QAAnB;UAAA,+EAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,+EAAmB;QAAnB;UAAA,+EAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,gFAAmB;QAAnB;UAAA,4EAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,0DAAmB;QAAnB;UAAA,yEAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,2DAAmB;QAAnB;UAAA,0EAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,gFAAmB;QAAnB;UAAA,+EAAmB;QAAA;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,4BAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,2BAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,+BAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,YAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,YAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA;QAAA,YAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,qCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wBAAmB;MAAnB,mBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,YAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,YAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,YAAmB;IAAA;EAAA;AADJ;AC76BjB;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,oHAAqO;EACrO,2JAA2J;AANlJ;AAQX;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,oHAAmO;EACnO,iMAAiM;AANxL;AAQX;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,oHAA2N;EAC3N,uKAAuK;AAN9J;AChBX;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,oHAAqO;EACrO,2JAA2J;AANlJ;AAQX;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,oHAAmO;EACnO,iMAAiM;AANxL;AAQX;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,sHAA2N;EAC3N,uKAAuK;AAN9J;ACDX;EAEE,2BAA4B;EAC5B,iCAAkC;EAClC,0BAA2B;EAC3B,yBAA0B;EAQ1B,kCAAmC;EACnC,yCAA0C;EAC1C,+BAAgC;EAEhC,oCAAqC;AACtC;AAED;EAEE,uBAAwB;EACxB,4BAA6B;EAC7B,8BAA+B;EAC/B,2BAA4B;EAG5B,yBAA0B;EAC1B,+BAAgC;EAChC,6BAA8B;EAG9B,6BAA8B;EAG9B,+BAAgC;EAChC,iCAAkC;EAGlC,oDAAqD;EACrD,0DAA2D;EAC3D,sCAAuC;EACvC,4CAA6C;EAC7C,yCAA0C;EAI1C,iCAAkC;EAClC,mCAAoC;EAIpC,wDAAyD;AAC1D;AAED;EAEE,uBAAwB;EACxB,4BAA6B;EAC7B,8BAA+B;EAC/B,2BAA4B;EAG5B,yBAA0B;EAC1B,+BAAgC;EAChC,6BAA8B;EAG9B,6BAA8B;EAG9B,+BAAgC;EAChC,iCAAkC;EAGlC,8CAA+C;EAC/C,qDAAsD;EACtD,uCAAwC;EACxC,6CAA8C;EAC9C,yCAA0C;EAI1C,iCAAkC;EAClC,iDAAkD;EAIlD,uDAAwD;AACzD;AAMD;;EAEE,oEAAqE;EACrE,eAAgB;EAChB,qCAAsC;EACtC,4BAA6B;AAC9B;AAMD;EACE,aAAc;EACd,0BAA2B;EAC3B,4BAA6B;EAC7B;UAES;EACT,YAAa;EACb,aAAc;EACd,gBAAiB;EACjB,qCAAsC;EACtC,4BAA6B;EAC7B,oEAAqE;EACrE,eAAgB;AACjB;AAMD;EACE,mBAAoB;EACpB,0CAA2C;EAC3C,gDAAiD;EACjD,aAAc;EACd,mBAAoB;EACpB,cAAe;EACf,QAAS;EACT,iBAAkB;EAClB,eAAgB;AACjB;AAED;;EAEE,aAAc;EACd,mBAAoB;EACpB,QAAS;EACT,cAAe;AAChB;AAGD;EACE,aAAc;EACd,mBAAoB;EACpB,uBAAwB;EACxB,WAAY;EACZ,YAAa;EACb,8BAA+B;EAC/B,eAAgB;EAChB,gBAAiB;EACjB,cAAe;EACf,cAAe;EAEf,kBAAmB;EACnB,eAAgB;EAChB,iBAAkB;AACnB;AAGD;EACE,OAAQ;EACR,aAAc;EACd,mBAAoB;EACpB,uBAAwB;EACxB,QAAS;EACT,gBAAiB;EACjB,cAAe;EACf,YAAa;EACb,eAAgB;EAChB,kBAAmB;EAEnB,4CAA6C;EAC7C,yCAA0C;EAC1C,kCAAmC;EACnC,eAAgB;EAChB,eAAgB;EAChB,gEAAiE;AAClE;AAED;EACE,uCAAwC;EACxC,uDAAwD;EACxD,4BAA6B;AAC9B;AAED;EACE,YAAa;EACb,cAAe;AAChB;AAGD;EACE,aAAc;EACd,mBAAoB;EACpB,uBAAwB;EACxB,WAAY;EACZ,YAAa;EACb,YAAa;EACb,gBAAiB;EACjB,kCAAmC;EACnC,eAAgB;EAChB,kBAAmB;EACnB,UAAW;EACX,6CAA8C;AAC/C;AAED;EACE,gDAAiD;EACjD,4BAA6B;AAC9B;AAED;EACE,YAAa;EACb,eAAgB;AACjB;AAGD;EACE,4BAA6B;EAC7B,gDAAiD;AAClD;AAID;EACE,oBAAqB;EACrB,mBAAoB;EACpB,QAAS;EACT,YAAa;EACb,eAAgB;EAChB,gBAAiB;EACjB,mBAAoB;EACpB,4CAA6C;EAC7C,yCAA0C;EAC1C,kCAAmC;EACnC,eAAgB;EAChB,cAAe;EACf,iBAAkB;EAClB,eAAgB;AACjB;AAED;EACE,UAAW;EACX,WAAY;EACZ,kBAAmB;EACnB,cAAe;EACf,6CAA8C;AAC/C;AAED;EACE,yBAA0B;EAC1B,0CAA2C;AAC5C;AAED;EACE,wCAAyC;EACzC,0CAA2C;AAC5C;AAED;EACE,6BAA8B;AAC/B;AAMD;EACE,mBAAoB;EACpB,2CAA4C;EAC5C,+CAAgD;EAChD,aAAc;EACd,sBAAuB;EACvB,8BAA+B;EAC/B,cAAe;AAChB;AAED;;EAEE,aAAc;EACd,sBAAuB;EACvB,mBAAoB;AACrB;AAGD;EACE,6CAA8C;EAC9C,gBAAiB;EACjB,eAAgB;AACjB;AAED;EACE,aAAc;EACd,mBAAoB;EACpB,uBAAwB;EACxB,WAAY;EACZ,YAAa;EACb,eAAgB;EAChB,kCAAmC;EACnC,kBAAmB;EACnB,sBAAuB;AACxB;AAED;EACE,4BAA6B;AAC9B;AAED;EACE,4BAA6B;EAC7B,8CAA+C;AAChD;AAGD;EACE,aAAc;EACd,mBAAoB;EACpB,uBAAwB;EACxB,WAAY;EACZ,YAAa;EACb,YAAa;EACb,gBAAiB;EACjB,gCAAiC;EACjC,eAAgB;EAChB,kBAAmB;EACnB,UAAW;EACX,cAAe;EACf,6CAA8C;AAC/C;AAED;EACE,gDAAiD;EACjD,kCAAmC;AACpC;AAGD;EACE;IACE,uBAAwB;EACzB;EACD;IACE,yBAA0B;EAC3B;AACF;AACD;EACE,wCAAyC;AAC1C;AAMD;EACE;IACE,UAAW;EACZ;EACD;IACE,UAAW;EACZ;AACF;AACD;EACE;IACE,uBAAwB;EACzB;EACD;IACE,uBAAwB;EACzB;AACF;AACD;EACE,aAAc;EACd,kEAAmE;AACpE;AACD;EACE,gBAAiB;AAClB;AAMD;EACE,eAAgB;EAChB,kBAAmB;EACnB,gBAAiB;AAClB;AAMD;EACE,iBAAkB;EAClB,yCAA0C;EAC1C,cAAe;EACf,aAAc;EACd,mBAAoB;EACpB,SAAU;EACV,eAAgB;EAChB,eAAgB;EAChB,mDAAoD;EACpD,iBAAkB;AACnB;AAED;EACE,YAAa;EACb,mBAAoB;AACrB;AAED;EACE,gBAAiB;AAClB;AAMD;EACE,WAAY;EACZ,YAAa;EACb,kBAAmB;EACnB,gBAAiB;EAGjB,8DAA+D;AAChE;AAED;EACE,aAAc;EACd,mBAAoB;EACpB,uBAAwB;EACxB,WAAY;EACZ,YAAa;EACb,gCAAiC;EACjC,eAAgB;AACjB;AAMD;EACE,aAAc;EACd,mBAAoB;EACpB,QAAS;EACT,cAAe;EACf,YAAa;EACb,eAAgB;EAChB,mBAAoB;EACpB,iBAAkB;AACnB;AAMD;EACE,aAAc;EACd,mBAAoB;EACpB,uBAAwB;EACxB,WAAY;EACZ,YAAa;EACb,YAAa;EACb,gBAAiB;EACjB,cAAe;EACf,eAAgB;EAChB,kBAAmB;EACnB,UAAW;EACX,UAAW;AACZ;AAGD;EACE,YAAa;AACd;AAED;EACE,qBAAsB;EACtB,uDAAwD;AACzD;AAMD;EAEE,0CAA2C;EAC3C,0CAA2C;EAC3C,gDAAiD;EACjD,iDAAkD;EAClD,gDAAiD;EACjD,oDAAqD;EACrD,4DAA6D;EAG7D,qDAAsD;EAGtD;;GAEE;EACF,4CAA6C;EAC7C,+CAAgD;EAGhD;;GAEE;EACF;;GAEE;EACF;;GAEE;EACF;;GAEE;EACF,8DAA+D;EAC/D,mEAAoE;EACpE,sEAAuE;EACvE,mEAAoE;EAGpE,+CAAgD;EAChD,8CAA+C;EAG/C,4BAA6B;EAC7B,+CAAgD;EAGhD,mDAAoD;AACrD;AAGD;;EAEE,mDAAoD;AACrD;AAGD;EACE,6CAA8C;AAC/C;AAID;EACE,+CAAgD;AACjD;AAGD;EACE,yCAA0C;EAC1C,YAAa;AACd;AAID;EACE,aAAc;AACf;AAKD;EACE,aAAc;AACf;AAID;EACE,aAAc;AACf;AAID;EACE,aAAc;EACd,mBAAoB;EACpB,uBAAwB;EACxB,YAAa;EACb,gCAAiC;EACjC,eAAgB;EAChB,iBAAkB;AACnB;AAMD;EACE,UAAW;EACX,WAAY;AACb;AAED;EACE,uBAAwB;AACzB;AAED;EACE,yCAA0C;EAC1C,kBAAmB;AACpB;AAED;EACE,2CAA4C;AAC7C;AAMD;EACE,eAAgB;EAChB,QAAS;EACT,WAAY;EACZ,2CAA4C;AAC7C;AAED;EACE,kBAAmB;EAGnB,QAAS;EACT,SAAU;EACV,2BAA4B;EAC5B,YAAa;EACb,iBAAkB;EAClB,aAAc;EACd,sBAAuB;EACvB,kBAAmB;EACnB,yCAA0C;EAC1C,0CAA2C;EAC3C,8CAA+C;EAC/C,gBAAiB;EACjB,mDAAoD;AACrD;AAED;EACE,WAAY;EACZ,kBAAmB;EACnB,YAAa;EACb,gDAAiD;EACjD,0CAA2C;EAC3C,4BAA6B;EAC7B,oBAAqB;EACrB,eAAgB;EAChB,aAAc;AACf;AAED;EACE,gCAAiC;AAClC;AAED;EACE,iBAAkB;EAClB,eAAgB;EAChB,kCAAmC;EACnC,gDAAiD;EACjD,4CAA6C;AAC9C;AAED;EACE,gBAAiB;EACjB,OAAQ;EACR,aAAc;AACf;AAED;EACE,aAAc;EACd,mBAAoB;EACpB,8BAA+B;EAC/B,iBAAkB;EAClB,eAAgB;EAChB,eAAgB;EAChB,4BAA6B;EAC7B,kCAAmC;AACpC;AAED;EACE,4CAA6C;AAC9C;AAED;EACE,wCAAyC;AAC1C;AAED;EACE,yCAA0C;AAC3C;AAED;EACE,OAAQ;EACR,YAAa;EACb,gBAAiB;EACjB,uBAAwB;EACxB,mBAAoB;AACrB;AAED;EACE,kCAAmC;AACpC;AAED;EACE,cAAe;EACf,iBAAkB;EAClB,gBAAiB;EACjB,kBAAmB;EACnB,yCAA0C;EAC1C,4CAA6C;EAC7C,kCAAmC;EACnC,eAAgB;AACjB;AAED;EACE,kBAAmB;EACnB,gCAAiC;EACjC,eAAgB;EAChB,kBAAmB;AACpB;AAID;EACE,iBAAkB;EAClB,eAAgB;EAChB,6CAA8C;EAC9C,gCAAiC;EACjC,eAAgB;EAChB,yBAA0B;EAC1B,sBAAuB;EACvB,iBAAkB;AACnB;AAID;EACE,eAAgB;EAChB,aAAc;AACf;AAED;EACE,6BAA8B;AAC/B;AAOD;EACE,iBAAkB;AACnB;AAGD;EACE,iBAAkB;EAClB,eAAgB;EAChB,kCAAmC;AACpC;AAED;EACE,4CAA6C;AAC9C;AAED;EACE,wCAAyC;AAC1C;AAED;EACE,yCAA0C;AAC3C;AAED;EACE,eAAgB;EAChB,4BAA6B;EAC7B,gBAAiB;EACjB,uBAAwB;EACxB,mBAAoB;AACrB;AAED;EACE,eAAgB;EAChB,kCAAmC;EACnC,gBAAiB;EACjB,uBAAwB;EACxB,mBAAoB;EACpB,eAAgB;AACjB;AAGD;EACE,qBAAsB;EACtB,eAAgB;EAChB,gBAAiB;EACjB,yBAA0B;EAC1B,sBAAuB;EACvB,gCAAiC;EACjC,iBAAkB;AACnB;AAGD;EACE,iBAAkB;EAClB,gBAAiB;EACjB,OAAQ;EACR,aAAc;AACf;AAED;EACE,kBAAmB;AACpB;AAED;EACE,cAAe;EACf,eAAgB;EAChB,4BAA6B;EAC7B,kBAAmB;AACpB;AAED;EACE,gCAAiC;EACjC,eAAgB;AACjB;AAED;EACE,WAAY;EACZ,gBAAiB;EACjB,yCAA0C;EAC1C,kBAAmB;EACnB,qCAAsC;EACtC,4BAA6B;EAC7B,mDAAoD;EACpD,eAAgB;EAChB,aAAc;EACd,sBAAuB;AACxB;AAED;EACE,qCAAsC;AACvC;AAED;EACE,oCAAqC;AACtC;AAED;EACE,oCAAqC;AACtC;AAED;EACE,uCAAwC;AACzC;AAED;EACE;;IAEE,wBAAyB;EAC1B;EACD;;IAEE,2BAA4B;EAC7B;EACD;;IAEE,0BAA2B;EAC5B;AACF;AAED;EACE,cAAe;EACf,eAAgB;EAChB,gCAAiC;EACjC,kBAAmB;EACnB,eAAgB;AACjB;AAED;EACE,cAAe;EACf,eAAgB;EAChB,6BAA8B;EAC9B,eAAgB;AACjB;AAGD;EACE,aAAc;EACd,mBAAoB;EACpB,QAAS;EACT,mBAAoB;EACpB,eAAgB;EAChB,4BAA6B;AAC9B;AAED;EACE,SAAU;AACX;AAED;EACE,aAAc;EACd,mBAAoB;EACpB,8BAA+B;EAC/B,iBAAkB;EAClB,6CAA8C;AAC/C;AAED;EACE,eAAgB;EAChB,gCAAiC;AAClC;AAED;EACE,iBAAkB;EAClB,yCAA0C;EAC1C,kBAAmB;EACnB,yCAA0C;EAC1C,WAAY;EACZ,eAAgB;EAChB,oBAAqB;EACrB,eAAgB;AACjB;AAED;EACE,YAAa;AACd;AAED;EACE,YAAa;EACb,mBAAoB;AACrB;AAMD;EACE,kBAAmB;EACnB,SAAU;EACV,OAAQ;EACR,gBAAiB;EACjB,0CAA2C;EAC3C,yCAA0C;EAC1C,kBAAmB;EACnB,oDAAqD;EACrD,aAAc;EACd,cAAe;AAChB;AAED;EACE,aAAc;EACd,mBAAoB;EACpB,WAAY;EACZ,iBAAkB;EAClB,YAAa;EACb,gBAAiB;EACjB,4BAA6B;EAC7B,eAAgB;EAChB,oBAAqB;EACrB,eAAgB;EAChB,gBAAiB;AAClB;AAED;EACE,yCAA0C;EAC1C,WAAY;AACb;AAED;EACE,WAAY;EACZ,yCAA0C;EAC1C,aAAc;AACf;AAGD;EACE,aAAc;EACd,mBAAoB;EACpB,uBAAwB;EACxB,WAAY;EACZ,YAAa;EACb,eAAgB;EAChB,iBAAkB;EAClB,iCAAkC;AACnC;AAED;EACE,gDAAiD;AAClD;AAED;EACE,eAAgB;EAChB,gBAAiB;EACjB,kCAAmC;EACnC,yBAA0B;AAC3B;AAGD;EACE,yBAA0B;EAC1B,uBAAwB;EACxB,sBAAuB;EACvB,qBAAsB;AACvB;AAGD;EACE,gBAAiB;EACjB,0CAA2C;EAC3C,yCAA0C;EAC1C,kBAAmB;EACnB,oDAAqD;EACrD,cAAe;EACf,cAAe;AAChB;AH/FC;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,oBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,wBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB,eAAmB;EAAnB,mBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,wBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB,eAAmB;EAAnB,mBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,wBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,wBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,kBAAmB;EAAnB,eAAmB;EAAnB,kBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,mBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,wBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,oBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,sBAAmB;EAAnB,eAAmB;EAAnB,mBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AA3ejB;EACE;IACE,yBAAyB;EADxB;AADW;AA2elB;EAAA;IAAA;MAAA,mBAAmB;MAAnB,mBAAmB;MAAnB,mBAAmB;MAAnB,sBAAmB;MAAnB,sBAAmB;MAAnB,sBAAmB;MAAnB,oBAAmB;MAAnB,oBAAmB;MAAnB,uBAAmB;MAAnB,wBAAmB;MAAnB,qBAAmB;MAAnB,yBAAmB;MAAnB,sBAAmB;MAAnB,qBAAmB;MAAnB,0BAAmB;MAAnB,4BAAmB;MAAnB,6BAAmB;MAAnB,8BAAmB;MAAnB,sBAAmB;MAAnB,0BAAmB;MAAnB,uBAAmB;MAAnB,4BAAmB;MAAnB,gCAAmB;MAAnB,6BAAmB;MAAnB,wBAAmB;MAAnB,2BAAmB;MAAnB,8BAAmB;MAAnB,iCAAmB;MAAnB,wBAAmB;MAAnB,2BAAmB;MAAnB,4BAAmB;MAAnB,kCAAmB;MAAnB,yBAAmB;MAAnB,kBAAmB;MAAnB,wBAAmB;MAAnB,sBAAmB;MAAnB,uBAAmB;MAAnB,wBAAmB;MAAnB,oBAAmB;MAAnB,qBAAmB;MAAnB,sBAAmB;MAAnB,mBAAmB;MAAnB,yBAAmB;MAAnB,+BAAmB;MAAnB,4BAAmB;MAAnB,8BAAmB;IAAA;EAAA;AAAA","sourcesContent":[null,"@layer theme, base, components, utilities;\n\n@layer theme {\n  @theme default {\n    --font-sans:\n      ui-sans-serif, system-ui, sans-serif, \"Apple Color Emoji\",\n      \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    --font-serif: ui-serif, Georgia, Cambria, \"Times New Roman\", Times, serif;\n    --font-mono:\n      ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\",\n      \"Courier New\", monospace;\n\n    --color-red-50: oklch(97.1% 0.013 17.38);\n    --color-red-100: oklch(93.6% 0.032 17.717);\n    --color-red-200: oklch(88.5% 0.062 18.334);\n    --color-red-300: oklch(80.8% 0.114 19.571);\n    --color-red-400: oklch(70.4% 0.191 22.216);\n    --color-red-500: oklch(63.7% 0.237 25.331);\n    --color-red-600: oklch(57.7% 0.245 27.325);\n    --color-red-700: oklch(50.5% 0.213 27.518);\n    --color-red-800: oklch(44.4% 0.177 26.899);\n    --color-red-900: oklch(39.6% 0.141 25.723);\n    --color-red-950: oklch(25.8% 0.092 26.042);\n\n    --color-orange-50: oklch(98% 0.016 73.684);\n    --color-orange-100: oklch(95.4% 0.038 75.164);\n    --color-orange-200: oklch(90.1% 0.076 70.697);\n    --color-orange-300: oklch(83.7% 0.128 66.29);\n    --color-orange-400: oklch(75% 0.183 55.934);\n    --color-orange-500: oklch(70.5% 0.213 47.604);\n    --color-orange-600: oklch(64.6% 0.222 41.116);\n    --color-orange-700: oklch(55.3% 0.195 38.402);\n    --color-orange-800: oklch(47% 0.157 37.304);\n    --color-orange-900: oklch(40.8% 0.123 38.172);\n    --color-orange-950: oklch(26.6% 0.079 36.259);\n\n    --color-amber-50: oklch(98.7% 0.022 95.277);\n    --color-amber-100: oklch(96.2% 0.059 95.617);\n    --color-amber-200: oklch(92.4% 0.12 95.746);\n    --color-amber-300: oklch(87.9% 0.169 91.605);\n    --color-amber-400: oklch(82.8% 0.189 84.429);\n    --color-amber-500: oklch(76.9% 0.188 70.08);\n    --color-amber-600: oklch(66.6% 0.179 58.318);\n    --color-amber-700: oklch(55.5% 0.163 48.998);\n    --color-amber-800: oklch(47.3% 0.137 46.201);\n    --color-amber-900: oklch(41.4% 0.112 45.904);\n    --color-amber-950: oklch(27.9% 0.077 45.635);\n\n    --color-yellow-50: oklch(98.7% 0.026 102.212);\n    --color-yellow-100: oklch(97.3% 0.071 103.193);\n    --color-yellow-200: oklch(94.5% 0.129 101.54);\n    --color-yellow-300: oklch(90.5% 0.182 98.111);\n    --color-yellow-400: oklch(85.2% 0.199 91.936);\n    --color-yellow-500: oklch(79.5% 0.184 86.047);\n    --color-yellow-600: oklch(68.1% 0.162 75.834);\n    --color-yellow-700: oklch(55.4% 0.135 66.442);\n    --color-yellow-800: oklch(47.6% 0.114 61.907);\n    --color-yellow-900: oklch(42.1% 0.095 57.708);\n    --color-yellow-950: oklch(28.6% 0.066 53.813);\n\n    --color-lime-50: oklch(98.6% 0.031 120.757);\n    --color-lime-100: oklch(96.7% 0.067 122.328);\n    --color-lime-200: oklch(93.8% 0.127 124.321);\n    --color-lime-300: oklch(89.7% 0.196 126.665);\n    --color-lime-400: oklch(84.1% 0.238 128.85);\n    --color-lime-500: oklch(76.8% 0.233 130.85);\n    --color-lime-600: oklch(64.8% 0.2 131.684);\n    --color-lime-700: oklch(53.2% 0.157 131.589);\n    --color-lime-800: oklch(45.3% 0.124 130.933);\n    --color-lime-900: oklch(40.5% 0.101 131.063);\n    --color-lime-950: oklch(27.4% 0.072 132.109);\n\n    --color-green-50: oklch(98.2% 0.018 155.826);\n    --color-green-100: oklch(96.2% 0.044 156.743);\n    --color-green-200: oklch(92.5% 0.084 155.995);\n    --color-green-300: oklch(87.1% 0.15 154.449);\n    --color-green-400: oklch(79.2% 0.209 151.711);\n    --color-green-500: oklch(72.3% 0.219 149.579);\n    --color-green-600: oklch(62.7% 0.194 149.214);\n    --color-green-700: oklch(52.7% 0.154 150.069);\n    --color-green-800: oklch(44.8% 0.119 151.328);\n    --color-green-900: oklch(39.3% 0.095 152.535);\n    --color-green-950: oklch(26.6% 0.065 152.934);\n\n    --color-emerald-50: oklch(97.9% 0.021 166.113);\n    --color-emerald-100: oklch(95% 0.052 163.051);\n    --color-emerald-200: oklch(90.5% 0.093 164.15);\n    --color-emerald-300: oklch(84.5% 0.143 164.978);\n    --color-emerald-400: oklch(76.5% 0.177 163.223);\n    --color-emerald-500: oklch(69.6% 0.17 162.48);\n    --color-emerald-600: oklch(59.6% 0.145 163.225);\n    --color-emerald-700: oklch(50.8% 0.118 165.612);\n    --color-emerald-800: oklch(43.2% 0.095 166.913);\n    --color-emerald-900: oklch(37.8% 0.077 168.94);\n    --color-emerald-950: oklch(26.2% 0.051 172.552);\n\n    --color-teal-50: oklch(98.4% 0.014 180.72);\n    --color-teal-100: oklch(95.3% 0.051 180.801);\n    --color-teal-200: oklch(91% 0.096 180.426);\n    --color-teal-300: oklch(85.5% 0.138 181.071);\n    --color-teal-400: oklch(77.7% 0.152 181.912);\n    --color-teal-500: oklch(70.4% 0.14 182.503);\n    --color-teal-600: oklch(60% 0.118 184.704);\n    --color-teal-700: oklch(51.1% 0.096 186.391);\n    --color-teal-800: oklch(43.7% 0.078 188.216);\n    --color-teal-900: oklch(38.6% 0.063 188.416);\n    --color-teal-950: oklch(27.7% 0.046 192.524);\n\n    --color-cyan-50: oklch(98.4% 0.019 200.873);\n    --color-cyan-100: oklch(95.6% 0.045 203.388);\n    --color-cyan-200: oklch(91.7% 0.08 205.041);\n    --color-cyan-300: oklch(86.5% 0.127 207.078);\n    --color-cyan-400: oklch(78.9% 0.154 211.53);\n    --color-cyan-500: oklch(71.5% 0.143 215.221);\n    --color-cyan-600: oklch(60.9% 0.126 221.723);\n    --color-cyan-700: oklch(52% 0.105 223.128);\n    --color-cyan-800: oklch(45% 0.085 224.283);\n    --color-cyan-900: oklch(39.8% 0.07 227.392);\n    --color-cyan-950: oklch(30.2% 0.056 229.695);\n\n    --color-sky-50: oklch(97.7% 0.013 236.62);\n    --color-sky-100: oklch(95.1% 0.026 236.824);\n    --color-sky-200: oklch(90.1% 0.058 230.902);\n    --color-sky-300: oklch(82.8% 0.111 230.318);\n    --color-sky-400: oklch(74.6% 0.16 232.661);\n    --color-sky-500: oklch(68.5% 0.169 237.323);\n    --color-sky-600: oklch(58.8% 0.158 241.966);\n    --color-sky-700: oklch(50% 0.134 242.749);\n    --color-sky-800: oklch(44.3% 0.11 240.79);\n    --color-sky-900: oklch(39.1% 0.09 240.876);\n    --color-sky-950: oklch(29.3% 0.066 243.157);\n\n    --color-blue-50: oklch(97% 0.014 254.604);\n    --color-blue-100: oklch(93.2% 0.032 255.585);\n    --color-blue-200: oklch(88.2% 0.059 254.128);\n    --color-blue-300: oklch(80.9% 0.105 251.813);\n    --color-blue-400: oklch(70.7% 0.165 254.624);\n    --color-blue-500: oklch(62.3% 0.214 259.815);\n    --color-blue-600: oklch(54.6% 0.245 262.881);\n    --color-blue-700: oklch(48.8% 0.243 264.376);\n    --color-blue-800: oklch(42.4% 0.199 265.638);\n    --color-blue-900: oklch(37.9% 0.146 265.522);\n    --color-blue-950: oklch(28.2% 0.091 267.935);\n\n    --color-indigo-50: oklch(96.2% 0.018 272.314);\n    --color-indigo-100: oklch(93% 0.034 272.788);\n    --color-indigo-200: oklch(87% 0.065 274.039);\n    --color-indigo-300: oklch(78.5% 0.115 274.713);\n    --color-indigo-400: oklch(67.3% 0.182 276.935);\n    --color-indigo-500: oklch(58.5% 0.233 277.117);\n    --color-indigo-600: oklch(51.1% 0.262 276.966);\n    --color-indigo-700: oklch(45.7% 0.24 277.023);\n    --color-indigo-800: oklch(39.8% 0.195 277.366);\n    --color-indigo-900: oklch(35.9% 0.144 278.697);\n    --color-indigo-950: oklch(25.7% 0.09 281.288);\n\n    --color-violet-50: oklch(96.9% 0.016 293.756);\n    --color-violet-100: oklch(94.3% 0.029 294.588);\n    --color-violet-200: oklch(89.4% 0.057 293.283);\n    --color-violet-300: oklch(81.1% 0.111 293.571);\n    --color-violet-400: oklch(70.2% 0.183 293.541);\n    --color-violet-500: oklch(60.6% 0.25 292.717);\n    --color-violet-600: oklch(54.1% 0.281 293.009);\n    --color-violet-700: oklch(49.1% 0.27 292.581);\n    --color-violet-800: oklch(43.2% 0.232 292.759);\n    --color-violet-900: oklch(38% 0.189 293.745);\n    --color-violet-950: oklch(28.3% 0.141 291.089);\n\n    --color-purple-50: oklch(97.7% 0.014 308.299);\n    --color-purple-100: oklch(94.6% 0.033 307.174);\n    --color-purple-200: oklch(90.2% 0.063 306.703);\n    --color-purple-300: oklch(82.7% 0.119 306.383);\n    --color-purple-400: oklch(71.4% 0.203 305.504);\n    --color-purple-500: oklch(62.7% 0.265 303.9);\n    --color-purple-600: oklch(55.8% 0.288 302.321);\n    --color-purple-700: oklch(49.6% 0.265 301.924);\n    --color-purple-800: oklch(43.8% 0.218 303.724);\n    --color-purple-900: oklch(38.1% 0.176 304.987);\n    --color-purple-950: oklch(29.1% 0.149 302.717);\n\n    --color-fuchsia-50: oklch(97.7% 0.017 320.058);\n    --color-fuchsia-100: oklch(95.2% 0.037 318.852);\n    --color-fuchsia-200: oklch(90.3% 0.076 319.62);\n    --color-fuchsia-300: oklch(83.3% 0.145 321.434);\n    --color-fuchsia-400: oklch(74% 0.238 322.16);\n    --color-fuchsia-500: oklch(66.7% 0.295 322.15);\n    --color-fuchsia-600: oklch(59.1% 0.293 322.896);\n    --color-fuchsia-700: oklch(51.8% 0.253 323.949);\n    --color-fuchsia-800: oklch(45.2% 0.211 324.591);\n    --color-fuchsia-900: oklch(40.1% 0.17 325.612);\n    --color-fuchsia-950: oklch(29.3% 0.136 325.661);\n\n    --color-pink-50: oklch(97.1% 0.014 343.198);\n    --color-pink-100: oklch(94.8% 0.028 342.258);\n    --color-pink-200: oklch(89.9% 0.061 343.231);\n    --color-pink-300: oklch(82.3% 0.12 346.018);\n    --color-pink-400: oklch(71.8% 0.202 349.761);\n    --color-pink-500: oklch(65.6% 0.241 354.308);\n    --color-pink-600: oklch(59.2% 0.249 0.584);\n    --color-pink-700: oklch(52.5% 0.223 3.958);\n    --color-pink-800: oklch(45.9% 0.187 3.815);\n    --color-pink-900: oklch(40.8% 0.153 2.432);\n    --color-pink-950: oklch(28.4% 0.109 3.907);\n\n    --color-rose-50: oklch(96.9% 0.015 12.422);\n    --color-rose-100: oklch(94.1% 0.03 12.58);\n    --color-rose-200: oklch(89.2% 0.058 10.001);\n    --color-rose-300: oklch(81% 0.117 11.638);\n    --color-rose-400: oklch(71.2% 0.194 13.428);\n    --color-rose-500: oklch(64.5% 0.246 16.439);\n    --color-rose-600: oklch(58.6% 0.253 17.585);\n    --color-rose-700: oklch(51.4% 0.222 16.935);\n    --color-rose-800: oklch(45.5% 0.188 13.697);\n    --color-rose-900: oklch(41% 0.159 10.272);\n    --color-rose-950: oklch(27.1% 0.105 12.094);\n\n    --color-slate-50: oklch(98.4% 0.003 247.858);\n    --color-slate-100: oklch(96.8% 0.007 247.896);\n    --color-slate-200: oklch(92.9% 0.013 255.508);\n    --color-slate-300: oklch(86.9% 0.022 252.894);\n    --color-slate-400: oklch(70.4% 0.04 256.788);\n    --color-slate-500: oklch(55.4% 0.046 257.417);\n    --color-slate-600: oklch(44.6% 0.043 257.281);\n    --color-slate-700: oklch(37.2% 0.044 257.287);\n    --color-slate-800: oklch(27.9% 0.041 260.031);\n    --color-slate-900: oklch(20.8% 0.042 265.755);\n    --color-slate-950: oklch(12.9% 0.042 264.695);\n\n    --color-gray-50: oklch(98.5% 0.002 247.839);\n    --color-gray-100: oklch(96.7% 0.003 264.542);\n    --color-gray-200: oklch(92.8% 0.006 264.531);\n    --color-gray-300: oklch(87.2% 0.01 258.338);\n    --color-gray-400: oklch(70.7% 0.022 261.325);\n    --color-gray-500: oklch(55.1% 0.027 264.364);\n    --color-gray-600: oklch(44.6% 0.03 256.802);\n    --color-gray-700: oklch(37.3% 0.034 259.733);\n    --color-gray-800: oklch(27.8% 0.033 256.848);\n    --color-gray-900: oklch(21% 0.034 264.665);\n    --color-gray-950: oklch(13% 0.028 261.692);\n\n    --color-zinc-50: oklch(98.5% 0 0);\n    --color-zinc-100: oklch(96.7% 0.001 286.375);\n    --color-zinc-200: oklch(92% 0.004 286.32);\n    --color-zinc-300: oklch(87.1% 0.006 286.286);\n    --color-zinc-400: oklch(70.5% 0.015 286.067);\n    --color-zinc-500: oklch(55.2% 0.016 285.938);\n    --color-zinc-600: oklch(44.2% 0.017 285.786);\n    --color-zinc-700: oklch(37% 0.013 285.805);\n    --color-zinc-800: oklch(27.4% 0.006 286.033);\n    --color-zinc-900: oklch(21% 0.006 285.885);\n    --color-zinc-950: oklch(14.1% 0.005 285.823);\n\n    --color-neutral-50: oklch(98.5% 0 0);\n    --color-neutral-100: oklch(97% 0 0);\n    --color-neutral-200: oklch(92.2% 0 0);\n    --color-neutral-300: oklch(87% 0 0);\n    --color-neutral-400: oklch(70.8% 0 0);\n    --color-neutral-500: oklch(55.6% 0 0);\n    --color-neutral-600: oklch(43.9% 0 0);\n    --color-neutral-700: oklch(37.1% 0 0);\n    --color-neutral-800: oklch(26.9% 0 0);\n    --color-neutral-900: oklch(20.5% 0 0);\n    --color-neutral-950: oklch(14.5% 0 0);\n\n    --color-stone-50: oklch(98.5% 0.001 106.423);\n    --color-stone-100: oklch(97% 0.001 106.424);\n    --color-stone-200: oklch(92.3% 0.003 48.717);\n    --color-stone-300: oklch(86.9% 0.005 56.366);\n    --color-stone-400: oklch(70.9% 0.01 56.259);\n    --color-stone-500: oklch(55.3% 0.013 58.071);\n    --color-stone-600: oklch(44.4% 0.011 73.639);\n    --color-stone-700: oklch(37.4% 0.01 67.558);\n    --color-stone-800: oklch(26.8% 0.007 34.298);\n    --color-stone-900: oklch(21.6% 0.006 56.043);\n    --color-stone-950: oklch(14.7% 0.004 49.25);\n\n    --color-mauve-50: oklch(98.5% 0 0);\n    --color-mauve-100: oklch(96% 0.003 325.6);\n    --color-mauve-200: oklch(92.2% 0.005 325.62);\n    --color-mauve-300: oklch(86.5% 0.012 325.68);\n    --color-mauve-400: oklch(71.1% 0.019 323.02);\n    --color-mauve-500: oklch(54.2% 0.034 322.5);\n    --color-mauve-600: oklch(43.5% 0.029 321.78);\n    --color-mauve-700: oklch(36.4% 0.029 323.89);\n    --color-mauve-800: oklch(26.3% 0.024 320.12);\n    --color-mauve-900: oklch(21.2% 0.019 322.12);\n    --color-mauve-950: oklch(14.5% 0.008 326);\n\n    --color-olive-50: oklch(98.8% 0.003 106.5);\n    --color-olive-100: oklch(96.6% 0.005 106.5);\n    --color-olive-200: oklch(93% 0.007 106.5);\n    --color-olive-300: oklch(88% 0.011 106.6);\n    --color-olive-400: oklch(73.7% 0.021 106.9);\n    --color-olive-500: oklch(58% 0.031 107.3);\n    --color-olive-600: oklch(46.6% 0.025 107.3);\n    --color-olive-700: oklch(39.4% 0.023 107.4);\n    --color-olive-800: oklch(28.6% 0.016 107.4);\n    --color-olive-900: oklch(22.8% 0.013 107.4);\n    --color-olive-950: oklch(15.3% 0.006 107.1);\n\n    --color-mist-50: oklch(98.7% 0.002 197.1);\n    --color-mist-100: oklch(96.3% 0.002 197.1);\n    --color-mist-200: oklch(92.5% 0.005 214.3);\n    --color-mist-300: oklch(87.2% 0.007 219.6);\n    --color-mist-400: oklch(72.3% 0.014 214.4);\n    --color-mist-500: oklch(56% 0.021 213.5);\n    --color-mist-600: oklch(45% 0.017 213.2);\n    --color-mist-700: oklch(37.8% 0.015 216);\n    --color-mist-800: oklch(27.5% 0.011 216.9);\n    --color-mist-900: oklch(21.8% 0.008 223.9);\n    --color-mist-950: oklch(14.8% 0.004 228.8);\n\n    --color-taupe-50: oklch(98.6% 0.002 67.8);\n    --color-taupe-100: oklch(96% 0.002 17.2);\n    --color-taupe-200: oklch(92.2% 0.005 34.3);\n    --color-taupe-300: oklch(86.8% 0.007 39.5);\n    --color-taupe-400: oklch(71.4% 0.014 41.2);\n    --color-taupe-500: oklch(54.7% 0.021 43.1);\n    --color-taupe-600: oklch(43.8% 0.017 39.3);\n    --color-taupe-700: oklch(36.7% 0.016 35.7);\n    --color-taupe-800: oklch(26.8% 0.011 36.5);\n    --color-taupe-900: oklch(21.4% 0.009 43.1);\n    --color-taupe-950: oklch(14.7% 0.004 49.3);\n\n    --color-black: #000;\n    --color-white: #fff;\n\n    --spacing: 0.25rem;\n\n    --breakpoint-sm: 40rem;\n    --breakpoint-md: 48rem;\n    --breakpoint-lg: 64rem;\n    --breakpoint-xl: 80rem;\n    --breakpoint-2xl: 96rem;\n\n    --container-3xs: 16rem;\n    --container-2xs: 18rem;\n    --container-xs: 20rem;\n    --container-sm: 24rem;\n    --container-md: 28rem;\n    --container-lg: 32rem;\n    --container-xl: 36rem;\n    --container-2xl: 42rem;\n    --container-3xl: 48rem;\n    --container-4xl: 56rem;\n    --container-5xl: 64rem;\n    --container-6xl: 72rem;\n    --container-7xl: 80rem;\n\n    --text-xs: 0.75rem;\n    --text-xs--line-height: calc(1 / 0.75);\n    --text-sm: 0.875rem;\n    --text-sm--line-height: calc(1.25 / 0.875);\n    --text-base: 1rem;\n    --text-base--line-height: calc(1.5 / 1);\n    --text-lg: 1.125rem;\n    --text-lg--line-height: calc(1.75 / 1.125);\n    --text-xl: 1.25rem;\n    --text-xl--line-height: calc(1.75 / 1.25);\n    --text-2xl: 1.5rem;\n    --text-2xl--line-height: calc(2 / 1.5);\n    --text-3xl: 1.875rem;\n    --text-3xl--line-height: calc(2.25 / 1.875);\n    --text-4xl: 2.25rem;\n    --text-4xl--line-height: calc(2.5 / 2.25);\n    --text-5xl: 3rem;\n    --text-5xl--line-height: 1;\n    --text-6xl: 3.75rem;\n    --text-6xl--line-height: 1;\n    --text-7xl: 4.5rem;\n    --text-7xl--line-height: 1;\n    --text-8xl: 6rem;\n    --text-8xl--line-height: 1;\n    --text-9xl: 8rem;\n    --text-9xl--line-height: 1;\n\n    --font-weight-thin: 100;\n    --font-weight-extralight: 200;\n    --font-weight-light: 300;\n    --font-weight-normal: 400;\n    --font-weight-medium: 500;\n    --font-weight-semibold: 600;\n    --font-weight-bold: 700;\n    --font-weight-extrabold: 800;\n    --font-weight-black: 900;\n\n    --tracking-tighter: -0.05em;\n    --tracking-tight: -0.025em;\n    --tracking-normal: 0em;\n    --tracking-wide: 0.025em;\n    --tracking-wider: 0.05em;\n    --tracking-widest: 0.1em;\n\n    --leading-tight: 1.25;\n    --leading-snug: 1.375;\n    --leading-normal: 1.5;\n    --leading-relaxed: 1.625;\n    --leading-loose: 2;\n\n    --radius-xs: 0.125rem;\n    --radius-sm: 0.25rem;\n    --radius-md: 0.375rem;\n    --radius-lg: 0.5rem;\n    --radius-xl: 0.75rem;\n    --radius-2xl: 1rem;\n    --radius-3xl: 1.5rem;\n    --radius-4xl: 2rem;\n\n    --shadow-2xs: 0 1px rgb(0 0 0 / 0.05);\n    --shadow-xs: 0 1px 2px 0 rgb(0 0 0 / 0.05);\n    --shadow-sm: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);\n    --shadow-md:\n      0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);\n    --shadow-lg:\n      0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);\n    --shadow-xl:\n      0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);\n    --shadow-2xl: 0 25px 50px -12px rgb(0 0 0 / 0.25);\n\n    --inset-shadow-2xs: inset 0 1px rgb(0 0 0 / 0.05);\n    --inset-shadow-xs: inset 0 1px 1px rgb(0 0 0 / 0.05);\n    --inset-shadow-sm: inset 0 2px 4px rgb(0 0 0 / 0.05);\n\n    --drop-shadow-xs: 0 1px 1px rgb(0 0 0 / 0.05);\n    --drop-shadow-sm: 0 1px 2px rgb(0 0 0 / 0.15);\n    --drop-shadow-md: 0 3px 3px rgb(0 0 0 / 0.12);\n    --drop-shadow-lg: 0 4px 4px rgb(0 0 0 / 0.15);\n    --drop-shadow-xl: 0 9px 7px rgb(0 0 0 / 0.1);\n    --drop-shadow-2xl: 0 25px 25px rgb(0 0 0 / 0.15);\n\n    --text-shadow-2xs: 0px 1px 0px rgb(0 0 0 / 0.15);\n    --text-shadow-xs: 0px 1px 1px rgb(0 0 0 / 0.2);\n    --text-shadow-sm:\n      0px 1px 0px rgb(0 0 0 / 0.075), 0px 1px 1px rgb(0 0 0 / 0.075),\n      0px 2px 2px rgb(0 0 0 / 0.075);\n    --text-shadow-md:\n      0px 1px 1px rgb(0 0 0 / 0.1), 0px 1px 2px rgb(0 0 0 / 0.1),\n      0px 2px 4px rgb(0 0 0 / 0.1);\n    --text-shadow-lg:\n      0px 1px 2px rgb(0 0 0 / 0.1), 0px 3px 2px rgb(0 0 0 / 0.1),\n      0px 4px 8px rgb(0 0 0 / 0.1);\n\n    --ease-in: cubic-bezier(0.4, 0, 1, 1);\n    --ease-out: cubic-bezier(0, 0, 0.2, 1);\n    --ease-in-out: cubic-bezier(0.4, 0, 0.2, 1);\n\n    --animate-spin: spin 1s linear infinite;\n    --animate-ping: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;\n    --animate-pulse: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;\n    --animate-bounce: bounce 1s infinite;\n\n    @keyframes spin {\n      to {\n        transform: rotate(360deg);\n      }\n    }\n\n    @keyframes ping {\n      75%,\n      100% {\n        transform: scale(2);\n        opacity: 0;\n      }\n    }\n\n    @keyframes pulse {\n      50% {\n        opacity: 0.5;\n      }\n    }\n\n    @keyframes bounce {\n      0%,\n      100% {\n        transform: translateY(-25%);\n        animation-timing-function: cubic-bezier(0.8, 0, 1, 1);\n      }\n\n      50% {\n        transform: none;\n        animation-timing-function: cubic-bezier(0, 0, 0.2, 1);\n      }\n    }\n\n    --blur-xs: 4px;\n    --blur-sm: 8px;\n    --blur-md: 12px;\n    --blur-lg: 16px;\n    --blur-xl: 24px;\n    --blur-2xl: 40px;\n    --blur-3xl: 64px;\n\n    --perspective-dramatic: 100px;\n    --perspective-near: 300px;\n    --perspective-normal: 500px;\n    --perspective-midrange: 800px;\n    --perspective-distant: 1200px;\n\n    --aspect-video: 16 / 9;\n\n    --default-transition-duration: 150ms;\n    --default-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n    --default-font-family: --theme(--font-sans, initial);\n    --default-font-feature-settings: --theme(\n      --font-sans--font-feature-settings,\n      initial\n    );\n    --default-font-variation-settings: --theme(\n      --font-sans--font-variation-settings,\n      initial\n    );\n    --default-mono-font-family: --theme(--font-mono, initial);\n    --default-mono-font-feature-settings: --theme(\n      --font-mono--font-feature-settings,\n      initial\n    );\n    --default-mono-font-variation-settings: --theme(\n      --font-mono--font-variation-settings,\n      initial\n    );\n  }\n\n  /* Deprecated */\n  @theme default inline reference {\n    --blur: 8px;\n    --shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);\n    --shadow-inner: inset 0 2px 4px 0 rgb(0 0 0 / 0.05);\n    --drop-shadow: 0 1px 2px rgb(0 0 0 / 0.1), 0 1px 1px rgb(0 0 0 / 0.06);\n    --radius: 0.25rem;\n    --max-width-prose: 65ch;\n  }\n}\n\n@layer base {\n  /*\n  1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)\n  2. Remove default margins and padding\n  3. Reset all borders.\n*/\n\n  *,\n  ::after,\n  ::before,\n  ::backdrop,\n  ::file-selector-button {\n    box-sizing: border-box; /* 1 */\n    margin: 0; /* 2 */\n    padding: 0; /* 2 */\n    border: 0 solid; /* 3 */\n  }\n\n  /*\n  1. Use a consistent sensible line-height in all browsers.\n  2. Prevent adjustments of font size after orientation changes in iOS.\n  3. Use a more readable tab size.\n  4. Use the user's configured `sans` font-family by default.\n  5. Use the user's configured `sans` font-feature-settings by default.\n  6. Use the user's configured `sans` font-variation-settings by default.\n  7. Disable tap highlights on iOS.\n*/\n\n  html,\n  :host {\n    line-height: 1.5; /* 1 */\n    -webkit-text-size-adjust: 100%; /* 2 */\n    tab-size: 4; /* 3 */\n    font-family: --theme(\n      --default-font-family,\n      ui-sans-serif,\n      system-ui,\n      sans-serif,\n      \"Apple Color Emoji\",\n      \"Segoe UI Emoji\",\n      \"Segoe UI Symbol\",\n      \"Noto Color Emoji\"\n    ); /* 4 */\n    font-feature-settings: --theme(\n      --default-font-feature-settings,\n      normal\n    ); /* 5 */\n    font-variation-settings: --theme(\n      --default-font-variation-settings,\n      normal\n    ); /* 6 */\n    -webkit-tap-highlight-color: transparent; /* 7 */\n  }\n\n  /*\n  1. Add the correct height in Firefox.\n  2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)\n  3. Reset the default border style to a 1px solid border.\n*/\n\n  hr {\n    height: 0; /* 1 */\n    color: inherit; /* 2 */\n    border-top-width: 1px; /* 3 */\n  }\n\n  /*\n  Add the correct text decoration in Chrome, Edge, and Safari.\n*/\n\n  abbr:where([title]) {\n    -webkit-text-decoration: underline dotted;\n    text-decoration: underline dotted;\n  }\n\n  /*\n  Remove the default font size and weight for headings.\n*/\n\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    font-size: inherit;\n    font-weight: inherit;\n  }\n\n  /*\n  Reset links to optimize for opt-in styling instead of opt-out.\n*/\n\n  a {\n    color: inherit;\n    -webkit-text-decoration: inherit;\n    text-decoration: inherit;\n  }\n\n  /*\n  Add the correct font weight in Edge and Safari.\n*/\n\n  b,\n  strong {\n    font-weight: bolder;\n  }\n\n  /*\n  1. Use the user's configured `mono` font-family by default.\n  2. Use the user's configured `mono` font-feature-settings by default.\n  3. Use the user's configured `mono` font-variation-settings by default.\n  4. Correct the odd `em` font sizing in all browsers.\n*/\n\n  code,\n  kbd,\n  samp,\n  pre {\n    font-family: --theme(\n      --default-mono-font-family,\n      ui-monospace,\n      SFMono-Regular,\n      Menlo,\n      Monaco,\n      Consolas,\n      \"Liberation Mono\",\n      \"Courier New\",\n      monospace\n    ); /* 1 */\n    font-feature-settings: --theme(\n      --default-mono-font-feature-settings,\n      normal\n    ); /* 2 */\n    font-variation-settings: --theme(\n      --default-mono-font-variation-settings,\n      normal\n    ); /* 3 */\n    font-size: 1em; /* 4 */\n  }\n\n  /*\n  Add the correct font size in all browsers.\n*/\n\n  small {\n    font-size: 80%;\n  }\n\n  /*\n  Prevent `sub` and `sup` elements from affecting the line height in all browsers.\n*/\n\n  sub,\n  sup {\n    font-size: 75%;\n    line-height: 0;\n    position: relative;\n    vertical-align: baseline;\n  }\n\n  sub {\n    bottom: -0.25em;\n  }\n\n  sup {\n    top: -0.5em;\n  }\n\n  /*\n  1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)\n  2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)\n  3. Remove gaps between table borders by default.\n*/\n\n  table {\n    text-indent: 0; /* 1 */\n    border-color: inherit; /* 2 */\n    border-collapse: collapse; /* 3 */\n  }\n\n  /*\n  Use the modern Firefox focus style for all focusable elements.\n*/\n\n  :-moz-focusring {\n    outline: auto;\n  }\n\n  /*\n  Add the correct vertical alignment in Chrome and Firefox.\n*/\n\n  progress {\n    vertical-align: baseline;\n  }\n\n  /*\n  Add the correct display in Chrome and Safari.\n*/\n\n  summary {\n    display: list-item;\n  }\n\n  /*\n  Make lists unstyled by default.\n*/\n\n  ol,\n  ul,\n  menu {\n    list-style: none;\n  }\n\n  /*\n  1. Make replaced elements `display: block` by default. (https://github.com/mozdevs/cssremedy/issues/14)\n  2. Add `vertical-align: middle` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)\n      This can trigger a poorly considered lint error in some tools but is included by design.\n*/\n\n  img,\n  svg,\n  video,\n  canvas,\n  audio,\n  iframe,\n  embed,\n  object {\n    display: block; /* 1 */\n    vertical-align: middle; /* 2 */\n  }\n\n  /*\n  Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)\n*/\n\n  img,\n  video {\n    max-width: 100%;\n    height: auto;\n  }\n\n  /*\n  1. Inherit font styles in all browsers.\n  2. Remove border radius in all browsers.\n  3. Remove background color in all browsers.\n  4. Ensure consistent opacity for disabled states in all browsers.\n*/\n\n  button,\n  input,\n  select,\n  optgroup,\n  textarea,\n  ::file-selector-button {\n    font: inherit; /* 1 */\n    font-feature-settings: inherit; /* 1 */\n    font-variation-settings: inherit; /* 1 */\n    letter-spacing: inherit; /* 1 */\n    color: inherit; /* 1 */\n    border-radius: 0; /* 2 */\n    background-color: transparent; /* 3 */\n    opacity: 1; /* 4 */\n  }\n\n  /*\n  Restore default font weight.\n*/\n\n  :where(select:is([multiple], [size])) optgroup {\n    font-weight: bolder;\n  }\n\n  /*\n  Restore indentation.\n*/\n\n  :where(select:is([multiple], [size])) optgroup option {\n    padding-inline-start: 20px;\n  }\n\n  /*\n  Restore space after button.\n*/\n\n  ::file-selector-button {\n    margin-inline-end: 4px;\n  }\n\n  /*\n  Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)\n*/\n\n  ::placeholder {\n    opacity: 1;\n  }\n\n  /*\n  Set the default placeholder color to a semi-transparent version of the current text color in browsers that do not\n  crash when using `color-mix(…)` with `currentcolor`. (https://github.com/tailwindlabs/tailwindcss/issues/17194)\n*/\n\n  @supports (not (-webkit-appearance: -apple-pay-button)) /* Not Safari */ or\n    (contain-intrinsic-size: 1px) /* Safari 17+ */ {\n    ::placeholder {\n      color: color-mix(in oklab, currentcolor 50%, transparent);\n    }\n  }\n\n  /*\n  Prevent resizing textareas horizontally by default.\n*/\n\n  textarea {\n    resize: vertical;\n  }\n\n  /*\n  Remove the inner padding in Chrome and Safari on macOS.\n*/\n\n  ::-webkit-search-decoration {\n    -webkit-appearance: none;\n  }\n\n  /*\n  1. Ensure date/time inputs have the same height when empty in iOS Safari.\n  2. Ensure text alignment can be changed on date/time inputs in iOS Safari.\n*/\n\n  ::-webkit-date-and-time-value {\n    min-height: 1lh; /* 1 */\n    text-align: inherit; /* 2 */\n  }\n\n  /*\n  Prevent height from changing on date/time inputs in macOS Safari when the input is set to `display: block`.\n*/\n\n  ::-webkit-datetime-edit {\n    display: inline-flex;\n  }\n\n  /*\n  Remove excess padding from pseudo-elements in date/time inputs to ensure consistent height across browsers.\n*/\n\n  ::-webkit-datetime-edit-fields-wrapper {\n    padding: 0;\n  }\n\n  ::-webkit-datetime-edit,\n  ::-webkit-datetime-edit-year-field,\n  ::-webkit-datetime-edit-month-field,\n  ::-webkit-datetime-edit-day-field,\n  ::-webkit-datetime-edit-hour-field,\n  ::-webkit-datetime-edit-minute-field,\n  ::-webkit-datetime-edit-second-field,\n  ::-webkit-datetime-edit-millisecond-field,\n  ::-webkit-datetime-edit-meridiem-field {\n    padding-block: 0;\n  }\n\n  /*\n  Center dropdown marker shown on inputs with paired `<datalist>`s in Chrome. (https://github.com/tailwindlabs/tailwindcss/issues/18499)\n*/\n\n  ::-webkit-calendar-picker-indicator {\n    line-height: 1;\n  }\n\n  /*\n  Remove the additional `:invalid` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)\n*/\n\n  :-moz-ui-invalid {\n    box-shadow: none;\n  }\n\n  /*\n  Correct the inability to style the border radius in iOS Safari.\n*/\n\n  button,\n  input:where([type=\"button\"], [type=\"reset\"], [type=\"submit\"]),\n  ::file-selector-button {\n    appearance: button;\n  }\n\n  /*\n  Correct the cursor style of increment and decrement buttons in Safari.\n*/\n\n  ::-webkit-inner-spin-button,\n  ::-webkit-outer-spin-button {\n    height: auto;\n  }\n\n  /*\n  Make elements with the HTML hidden attribute stay hidden by default.\n*/\n\n  [hidden]:where(:not([hidden=\"until-found\"])) {\n    display: none !important;\n  }\n}\n\n@layer utilities {\n  @tailwind utilities;\n}\n","@font-face {\n  font-family: 'Inconsolata';\n  font-style: normal;\n  font-display: swap;\n  font-weight: 400;\n  src: url(../../../node_modules/@fontsource/inconsolata/files/inconsolata-vietnamese-400-normal.woff2) format('woff2'), url(../../../node_modules/@fontsource/inconsolata/files/inconsolata-vietnamese-400-normal.woff) format('woff');\n  unicode-range: U+0102-0103,U+0110-0111,U+0128-0129,U+0168-0169,U+01A0-01A1,U+01AF-01B0,U+0300-0301,U+0303-0304,U+0308-0309,U+0323,U+0329,U+1EA0-1EF9,U+20AB;\n}\n@font-face {\n  font-family: 'Inconsolata';\n  font-style: normal;\n  font-display: swap;\n  font-weight: 400;\n  src: url(../../../node_modules/@fontsource/inconsolata/files/inconsolata-latin-ext-400-normal.woff2) format('woff2'), url(../../../node_modules/@fontsource/inconsolata/files/inconsolata-latin-ext-400-normal.woff) format('woff');\n  unicode-range: U+0100-02BA,U+02BD-02C5,U+02C7-02CC,U+02CE-02D7,U+02DD-02FF,U+0304,U+0308,U+0329,U+1D00-1DBF,U+1E00-1E9F,U+1EF2-1EFF,U+2020,U+20A0-20AB,U+20AD-20C0,U+2113,U+2C60-2C7F,U+A720-A7FF;\n}\n@font-face {\n  font-family: 'Inconsolata';\n  font-style: normal;\n  font-display: swap;\n  font-weight: 400;\n  src: url(../../../node_modules/@fontsource/inconsolata/files/inconsolata-latin-400-normal.woff2) format('woff2'), url(../../../node_modules/@fontsource/inconsolata/files/inconsolata-latin-400-normal.woff) format('woff');\n  unicode-range: U+0000-00FF,U+0131,U+0152-0153,U+02BB-02BC,U+02C6,U+02DA,U+02DC,U+0304,U+0308,U+0329,U+2000-206F,U+20AC,U+2122,U+2191,U+2193,U+2212,U+2215,U+FEFF,U+FFFD;\n}\n","@font-face {\n  font-family: 'Inconsolata';\n  font-style: normal;\n  font-display: swap;\n  font-weight: 500;\n  src: url(../../../node_modules/@fontsource/inconsolata/files/inconsolata-vietnamese-500-normal.woff2) format('woff2'), url(../../../node_modules/@fontsource/inconsolata/files/inconsolata-vietnamese-500-normal.woff) format('woff');\n  unicode-range: U+0102-0103,U+0110-0111,U+0128-0129,U+0168-0169,U+01A0-01A1,U+01AF-01B0,U+0300-0301,U+0303-0304,U+0308-0309,U+0323,U+0329,U+1EA0-1EF9,U+20AB;\n}\n@font-face {\n  font-family: 'Inconsolata';\n  font-style: normal;\n  font-display: swap;\n  font-weight: 500;\n  src: url(../../../node_modules/@fontsource/inconsolata/files/inconsolata-latin-ext-500-normal.woff2) format('woff2'), url(../../../node_modules/@fontsource/inconsolata/files/inconsolata-latin-ext-500-normal.woff) format('woff');\n  unicode-range: U+0100-02BA,U+02BD-02C5,U+02C7-02CC,U+02CE-02D7,U+02DD-02FF,U+0304,U+0308,U+0329,U+1D00-1DBF,U+1E00-1E9F,U+1EF2-1EFF,U+2020,U+20A0-20AB,U+20AD-20C0,U+2113,U+2C60-2C7F,U+A720-A7FF;\n}\n@font-face {\n  font-family: 'Inconsolata';\n  font-style: normal;\n  font-display: swap;\n  font-weight: 500;\n  src: url(../../../node_modules/@fontsource/inconsolata/files/inconsolata-latin-500-normal.woff2) format('woff2'), url(../../../node_modules/@fontsource/inconsolata/files/inconsolata-latin-500-normal.woff) format('woff');\n  unicode-range: U+0000-00FF,U+0131,U+0152-0153,U+02BB-02BC,U+02C6,U+02DA,U+02DC,U+0304,U+0308,U+0329,U+2000-206F,U+20AC,U+2122,U+2191,U+2193,U+2212,U+2215,U+FEFF,U+FFFD;\n}\n","/*\n * # IDE Styles\n *\n * Tailwind CSS v4 entry point + IDE-specific theme variables and\n * structural overrides that can't be expressed purely as utility classes.\n */\n\n@import \"tailwindcss\";\n@import \"@fontsource/inconsolata/400.css\";\n@import \"@fontsource/inconsolata/500.css\";\n\n/* ------------------------------------------------------------------ */\n/* IDE colour palette and font tokens                                  */\n/* ------------------------------------------------------------------ */\n\n:root {\n  /* Theme-invariant tokens */\n  --color-ide-accent: #007acc;\n  --color-ide-accent-hover: #1a8ad4;\n  --color-ide-error: #f14c4c;\n  --color-ide-warn: #d9a441;\n\n  /* Agent-activity signal colours.\n     `working` is a brighter, more saturated sibling of the accent: it has to\n     win attention against a UI already full of accent-blue chrome while still\n     reading as the same family. `done` reuses the green already used by the\n     network-status dot. Both are theme-invariant, so the signal means the same\n     thing in either theme; only the soft wash below is theme-dependent. */\n  --color-ide-agent-working: #0a84ff;\n  --color-ide-agent-working-strong: #4aa8ff;\n  --color-ide-agent-done: #3fb950;\n  /* Text placed on top of a filled working/done surface. */\n  --color-ide-agent-on-strong: #ffffff;\n}\n\n:root[data-theme=\"dark\"] {\n  /* Surface colours */\n  --color-ide-bg: #1e1e1e;\n  --color-ide-surface: #252526;\n  --color-ide-surface-2: #2d2d2d;\n  --color-ide-border: #3c3c3c;\n\n  /* Text */\n  --color-ide-text: #cccccc;\n  --color-ide-text-muted: #888888;\n  --color-ide-text-dim: #555555;\n\n  /* Activity bar */\n  --color-ide-activity: #333333;\n\n  /* Tab colours */\n  --color-ide-tab-active: #1e1e1e;\n  --color-ide-tab-inactive: #2d2d30;\n\n  /* Overlays — light on dark */\n  --color-ide-hover-overlay: rgba(255, 255, 255, 0.07);\n  --color-ide-hover-overlay-strong: rgba(255, 255, 255, 0.1);\n  --color-ide-shadow: rgba(0, 0, 0, 0.5);\n  --color-ide-shadow-light: rgba(0, 0, 0, 0.3);\n  --color-ide-backdrop: rgba(0, 0, 0, 0.25);\n\n  /* Selection: solid background for selected list rows.\n     Dark blue reads well against the light text used in dark mode. */\n  --color-ide-selection-bg: #007acc;\n  --color-ide-selection-text: #ffffff;\n\n  /* Low-alpha wash of the working colour, used for the progress track and the\n     dot halo. Alpha rather than a blended hex so it sits on any surface. */\n  --color-ide-agent-working-soft: rgba(10, 132, 255, 0.28);\n}\n\n:root[data-theme=\"light\"] {\n  /* Surface colours */\n  --color-ide-bg: #e8e8e8; /* viewport — slightly darker light grey */\n  --color-ide-surface: #f3f3f3; /* sidebar — halfway between viewport and design */\n  --color-ide-surface-2: #e8e8e8;\n  --color-ide-border: #d4d4d4;\n\n  /* Text */\n  --color-ide-text: #333333;\n  --color-ide-text-muted: #666666;\n  --color-ide-text-dim: #999999;\n\n  /* Activity bar */\n  --color-ide-activity: #e0e0e0;\n\n  /* Tab colours */\n  --color-ide-tab-active: #ffffff;\n  --color-ide-tab-inactive: #ececec;\n\n  /* Overlays — dark on light */\n  --color-ide-hover-overlay: rgba(0, 0, 0, 0.05);\n  --color-ide-hover-overlay-strong: rgba(0, 0, 0, 0.08);\n  --color-ide-shadow: rgba(0, 0, 0, 0.15);\n  --color-ide-shadow-light: rgba(0, 0, 0, 0.12);\n  --color-ide-backdrop: rgba(0, 0, 0, 0.15);\n\n  /* Selection: light blue keeps enough contrast with the dark text used\n     in light mode — a dark-blue selection leaves text nearly unreadable. */\n  --color-ide-selection-bg: #cce6ff;\n  --color-ide-selection-text: var(--color-ide-text);\n\n  /* Slightly stronger than the dark-theme wash: the same alpha disappears\n     against light surfaces. */\n  --color-ide-agent-working-soft: rgba(10, 132, 255, 0.2);\n}\n\n/* ------------------------------------------------------------------ */\n/* Base: ensure Inconsolata loads globally                             */\n/* ------------------------------------------------------------------ */\n\nhtml,\nbody {\n  font-family: \"Inconsolata\", ui-monospace, \"Cascadia Code\", monospace;\n  font-size: 13px;\n  background-color: var(--color-ide-bg);\n  color: var(--color-ide-text);\n}\n\n/* ------------------------------------------------------------------ */\n/* Outer frame: CSS Grid for activity bar + dock area + status bar     */\n/* ------------------------------------------------------------------ */\n\n.ide-frame {\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-template-rows: 35px 1fr;\n  grid-template-areas:\n    \"titlebar\"\n    \"dock\";\n  width: 100vw;\n  height: 100vh;\n  overflow: hidden;\n  background-color: var(--color-ide-bg);\n  color: var(--color-ide-text);\n  font-family: \"Inconsolata\", ui-monospace, \"Cascadia Code\", monospace;\n  font-size: 13px;\n}\n\n/* ------------------------------------------------------------------ */\n/* Title bar                                                            */\n/* ------------------------------------------------------------------ */\n\n.ide-title-bar {\n  grid-area: titlebar;\n  background-color: var(--color-ide-surface);\n  border-bottom: 1px solid var(--color-ide-border);\n  display: flex;\n  align-items: center;\n  padding: 0 6px;\n  gap: 4px;\n  user-select: none;\n  font-size: 12px;\n}\n\n.ide-title-left,\n.ide-title-right {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n  flex-shrink: 0;\n}\n\n/* GenAlpha logo mark — blue α in the title bar */\n.ide-title-logo {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  color: var(--color-ide-accent);\n  font-size: 18px;\n  font-weight: 600;\n  line-height: 1;\n  flex-shrink: 0;\n  /* Keep italic Greek alpha look */\n  font-style: italic;\n  cursor: default;\n  user-select: none;\n}\n\n/* Command center — rounded pill in the middle of the title bar */\n.ide-title-command-center {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 5px;\n  max-width: 420px;\n  margin: 0 auto;\n  height: 24px;\n  padding: 0 12px;\n  border-radius: 6px;\n  /* Slightly lighter than title bar so it reads as a distinct interactive pill */\n  background-color: var(--color-ide-surface-2);\n  border: 1px solid var(--color-ide-border);\n  color: var(--color-ide-text-muted);\n  font-size: 12px;\n  cursor: pointer;\n  transition: border-color 0.1s, color 0.1s, background-color 0.1s;\n}\n\n.ide-title-command-center:hover {\n  border-color: var(--color-ide-text-dim);\n  background-color: var(--color-ide-hover-overlay-strong);\n  color: var(--color-ide-text);\n}\n\n.ide-title-command-icon {\n  opacity: 0.6;\n  flex-shrink: 0;\n}\n\n/* Icon buttons in the title bar */\n.ide-title-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 24px;\n  border: none;\n  background: none;\n  color: var(--color-ide-text-muted);\n  cursor: pointer;\n  border-radius: 4px;\n  padding: 0;\n  transition: background-color 0.1s, color 0.1s;\n}\n\n.ide-title-btn:hover:not(:disabled) {\n  background-color: var(--color-ide-hover-overlay);\n  color: var(--color-ide-text);\n}\n\n.ide-title-btn:disabled {\n  opacity: 0.3;\n  cursor: default;\n}\n\n/* Active state for panel toggle buttons — indicates the panel is visible */\n.ide-title-btn.ide-title-btn-active {\n  color: var(--color-ide-text);\n  background-color: var(--color-ide-hover-overlay);\n}\n\n/* Network connection status indicator — pill next to the nav arrows.\n   Dot color reflects WebSocket state; label text mirrors that state. */\n.ide-network-status {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 22px;\n  padding: 0 10px;\n  margin-left: 4px;\n  border-radius: 11px;\n  background-color: var(--color-ide-surface-2);\n  border: 1px solid var(--color-ide-border);\n  color: var(--color-ide-text-muted);\n  font-size: 11px;\n  line-height: 1;\n  user-select: none;\n  cursor: default;\n}\n\n.ide-network-status-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  flex-shrink: 0;\n  background-color: var(--color-ide-text-muted);\n}\n\n.ide-network-status[data-connected=\"true\"] .ide-network-status-dot {\n  background-color: #3fb950;\n  box-shadow: 0 0 4px rgba(63, 185, 80, 0.6);\n}\n\n.ide-network-status[data-connected=\"false\"] .ide-network-status-dot {\n  background-color: var(--color-ide-error);\n  box-shadow: 0 0 4px rgba(241, 76, 76, 0.6);\n}\n\n.ide-network-status[data-connected=\"false\"] .ide-network-status-label {\n  color: var(--color-ide-error);\n}\n\n/* ------------------------------------------------------------------ */\n/* Activity bar                                                         */\n/* ------------------------------------------------------------------ */\n\n.ide-activity-bar {\n  grid-area: activity;\n  background-color: var(--color-ide-activity);\n  border-right: 1px solid var(--color-ide-border);\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  padding: 4px 0;\n}\n\n.ide-activity-top,\n.ide-activity-bottom {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n/* Separator above bottom icons (accounts, settings) */\n.ide-activity-bottom {\n  border-top: 1px solid var(--color-ide-border);\n  padding-top: 4px;\n  margin-top: 4px;\n}\n\n.ide-activity-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 48px;\n  height: 40px;\n  cursor: pointer;\n  color: var(--color-ide-text-muted);\n  position: relative;\n  transition: color 0.1s;\n}\n\n.ide-activity-icon:hover {\n  color: var(--color-ide-text);\n}\n\n.ide-activity-icon-active {\n  color: var(--color-ide-text);\n  border-left: 2px solid var(--color-ide-accent);\n}\n\n/* Panel header icon buttons (hamburger, more-actions) */\n.ide-panel-header-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 22px;\n  height: 22px;\n  border: none;\n  background: none;\n  color: var(--color-ide-text-dim);\n  cursor: pointer;\n  border-radius: 3px;\n  padding: 0;\n  flex-shrink: 0;\n  transition: background-color 0.1s, color 0.1s;\n}\n\n.ide-panel-header-btn:hover {\n  background-color: var(--color-ide-hover-overlay);\n  color: var(--color-ide-text-muted);\n}\n\n/* Spinning refresh indicator */\n@keyframes ide-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n.ide-spin svg {\n  animation: ide-spin 0.8s linear infinite;\n}\n\n/* Gentle fade-in + slide-open for tree content appearing after load/expand.\n   Uses grid-template-rows 0fr→1fr to animate to the real content height.\n   Requires exactly one child element (the child gets overflow:hidden so\n   it collapses when the row is 0fr). */\n@keyframes ide-fade-in {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n@keyframes ide-slide-open {\n  from {\n    grid-template-rows: 0fr;\n  }\n  to {\n    grid-template-rows: 1fr;\n  }\n}\n.ide-fade-in {\n  display: grid;\n  animation: ide-fade-in 0.2s ease-out, ide-slide-open 0.2s ease-out;\n}\n.ide-fade-in > * {\n  overflow: hidden;\n}\n\n/* ------------------------------------------------------------------ */\n/* Dock area                                                            */\n/* ------------------------------------------------------------------ */\n\n.ide-dock-area {\n  grid-area: dock;\n  position: relative;\n  overflow: hidden;\n}\n\n/* ------------------------------------------------------------------ */\n/* Status bar                                                           */\n/* ------------------------------------------------------------------ */\n\n.ide-status-bar {\n  grid-area: status;\n  background-color: var(--color-ide-accent);\n  color: #ffffff;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 0 12px;\n  font-size: 11px;\n  font-family: \"Inconsolata\", ui-monospace, monospace;\n  user-select: none;\n}\n\n.ide-status-item {\n  opacity: 0.9;\n  white-space: nowrap;\n}\n\n.ide-status-accent {\n  font-weight: 600;\n}\n\n/* ------------------------------------------------------------------ */\n/* Editor pane: fills the dockview panel content area                   */\n/* ------------------------------------------------------------------ */\n\n.ide-editor-pane {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  overflow: hidden;\n  /* Use the EditorCore theme-driven canvas background when available,\n     falling back to the IDE surface colour otherwise. */\n  background-color: var(--editor-canvas-bg, var(--color-ide-bg));\n}\n\n.ide-editor-empty {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  color: var(--color-ide-text-dim);\n  font-size: 13px;\n}\n\n/* ------------------------------------------------------------------ */\n/* Editor tab header (inside dockview's native tab bar)                */\n/* ------------------------------------------------------------------ */\n\n.ide-editor-tab-header {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 0 8px;\n  height: 100%;\n  font-size: 13px;\n  white-space: nowrap;\n  user-select: none;\n}\n\n.ide-editor-tab-label {\n  /* no extra styling needed — inherits from dockview tab colours */\n}\n\n.ide-editor-tab-close {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  height: 16px;\n  border: none;\n  background: none;\n  color: inherit;\n  cursor: pointer;\n  border-radius: 3px;\n  padding: 0;\n  opacity: 0;\n}\n\n/* Show close button on hover — target the dockview tab wrapper */\n.dv-tab:hover .ide-editor-tab-close {\n  opacity: 0.7;\n}\n\n.ide-editor-tab-close:hover {\n  opacity: 1 !important;\n  background-color: var(--color-ide-hover-overlay-strong);\n}\n\n/* ------------------------------------------------------------------ */\n/* Dockview theme overrides — IDE colours + Inconsolata font             */\n/* ------------------------------------------------------------------ */\n\n.dockview-theme-abyss {\n  /* Palette remapped to IDE theme (light/dark via CSS variables) */\n  --dv-color-abyss-dark: var(--color-ide-bg);\n  --dv-color-abyss: var(--color-ide-surface);\n  --dv-color-abyss-light: var(--color-ide-surface);\n  --dv-color-abyss-lighter: var(--color-ide-border);\n  --dv-color-abyss-accent: var(--color-ide-accent);\n  --dv-color-abyss-primary-text: var(--color-ide-text);\n  --dv-color-abyss-secondary-text: var(--color-ide-text-muted);\n\n  /* Panel backgrounds */\n  --dv-group-view-background-color: var(--color-ide-bg);\n\n  /* Tab bar */\n  --dv-tabs-and-actions-container-background-color: var(\n    --color-ide-tab-inactive\n  );\n  --dv-tabs-and-actions-container-height: 35px;\n  --dv-tabs-and-actions-container-font-size: 12px;\n\n  /* Tabs */\n  --dv-activegroup-visiblepanel-tab-background-color: var(\n    --color-ide-tab-active\n  );\n  --dv-activegroup-hiddenpanel-tab-background-color: var(\n    --color-ide-tab-inactive\n  );\n  --dv-inactivegroup-visiblepanel-tab-background-color: var(\n    --color-ide-surface\n  );\n  --dv-inactivegroup-hiddenpanel-tab-background-color: var(\n    --color-ide-surface-2\n  );\n  --dv-activegroup-visiblepanel-tab-color: var(--color-ide-text);\n  --dv-activegroup-hiddenpanel-tab-color: var(--color-ide-text-muted);\n  --dv-inactivegroup-visiblepanel-tab-color: var(--color-ide-text-muted);\n  --dv-inactivegroup-hiddenpanel-tab-color: var(--color-ide-text-dim);\n\n  /* Dividers and separators */\n  --dv-tab-divider-color: var(--color-ide-border);\n  --dv-separator-border: var(--color-ide-border);\n\n  /* Resize handle (sash) — subtly visible on hover */\n  --dv-sash-color: transparent;\n  --dv-active-sash-color: var(--color-ide-accent);\n\n  /* Font */\n  font-family: \"Inconsolata\", ui-monospace, monospace;\n}\n\n/* Apply our font to all dockview text elements */\n.dockview-theme-abyss .dv-tab,\n.dockview-theme-abyss .dv-tabs-and-actions-container {\n  font-family: \"Inconsolata\", ui-monospace, monospace;\n}\n\n/* Active tab — blue top border (dv-active-group / dv-active-tab are dockview v5 class names) */\n.dockview-theme-abyss .dv-groupview.dv-active-group .dv-tab.dv-active-tab {\n  border-top: 2px solid var(--color-ide-accent);\n}\n\n/* Active tab in inactive groups (sidebars) — subtler indicator so the\n   selected tab is still visually distinct from its inactive siblings. */\n.dockview-theme-abyss .dv-groupview.dv-inactive-group .dv-tab.dv-active-tab {\n  border-top: 2px solid var(--color-ide-text-dim);\n}\n\n/* Make the sash (resize handle) slightly visible on hover */\n.dockview-theme-abyss .dv-sash:hover {\n  background-color: var(--color-ide-accent);\n  opacity: 0.6;\n}\n\n/* Hide dockview's built-in tab close button — editor tabs use a custom\n   close button in EditorTabHeader, and sidebar tabs don't need one. */\n.dockview-theme-abyss .dv-tab .dv-default-tab-action {\n  display: none;\n}\n\n/* Hide the tab for the editor-area placeholder panel. This panel holds the\n   center space in the layout; its tab should be invisible. The EditorAreaTab\n   component renders .ide-editor-area-marker which we target here. */\n.dockview-theme-abyss .dv-tab:has(.ide-editor-area-marker) {\n  display: none;\n}\n\n/* Hide the tab for sidebar placeholder panels. These keep sidebar groups\n   alive as drop targets when all real sidebar panels are dragged away. */\n.dockview-theme-abyss .dv-tab:has(.ide-sidebar-placeholder-marker) {\n  display: none;\n}\n\n/* Minimal empty state shown in a sidebar group when it only contains\n   the invisible placeholder panel. */\n.ide-sidebar-placeholder {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  color: var(--color-ide-text-dim);\n  font-size: 11px;\n  user-select: none;\n}\n\n/* ------------------------------------------------------------------ */\n/* Custom scrollbars — thin, matching the IDE theme                    */\n/* ------------------------------------------------------------------ */\n\n::-webkit-scrollbar {\n  width: 6px;\n  height: 6px;\n}\n\n::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n::-webkit-scrollbar-thumb {\n  background-color: var(--color-ide-border);\n  border-radius: 3px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background-color: var(--color-ide-text-dim);\n}\n\n/* ------------------------------------------------------------------ */\n/* Command Palette                                                     */\n/* ------------------------------------------------------------------ */\n\n.command-palette-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 50;\n  background-color: var(--color-ide-backdrop);\n}\n\n.command-palette {\n  position: absolute;\n  /* Align top with the command center pill in the title bar.\n     Title bar is 35px, pill is 24px, so pill top = (35-24)/2 ≈ 6px. */\n  top: 6px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 480px;\n  max-height: 340px;\n  display: flex;\n  flex-direction: column;\n  border-radius: 8px;\n  border: 1px solid var(--color-ide-border);\n  background-color: var(--color-ide-surface);\n  box-shadow: 0 8px 30px var(--color-ide-shadow);\n  overflow: hidden;\n  font-family: \"Inconsolata\", ui-monospace, monospace;\n}\n\n.command-palette-input {\n  width: 100%;\n  padding: 10px 14px;\n  border: none;\n  border-bottom: 1px solid var(--color-ide-border);\n  background-color: var(--color-ide-surface);\n  color: var(--color-ide-text);\n  font-family: inherit;\n  font-size: 13px;\n  outline: none;\n}\n\n.command-palette-input::placeholder {\n  color: var(--color-ide-text-dim);\n}\n\n.command-palette-prompt-label {\n  padding: 6px 14px;\n  font-size: 11px;\n  color: var(--color-ide-text-muted);\n  border-bottom: 1px solid var(--color-ide-border);\n  background-color: var(--color-ide-surface-2);\n}\n\n.command-palette-list {\n  overflow-y: auto;\n  flex: 1;\n  min-height: 0;\n}\n\n.command-palette-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 6px 14px;\n  cursor: pointer;\n  font-size: 13px;\n  color: var(--color-ide-text);\n  transition: background-color 0.05s;\n}\n\n.command-palette-row:hover {\n  background-color: var(--color-ide-surface-2);\n}\n\n.command-palette-row-selected {\n  background-color: rgba(0, 122, 204, 0.3);\n}\n\n.command-palette-row-selected:hover {\n  background-color: rgba(0, 122, 204, 0.35);\n}\n\n.command-palette-row-label {\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.command-palette-row-category {\n  color: var(--color-ide-text-muted);\n}\n\n.command-palette-keybinding {\n  flex-shrink: 0;\n  margin-left: 16px;\n  padding: 1px 6px;\n  border-radius: 3px;\n  border: 1px solid var(--color-ide-border);\n  background-color: var(--color-ide-surface-2);\n  color: var(--color-ide-text-muted);\n  font-size: 11px;\n}\n\n.command-palette-empty {\n  padding: 12px 14px;\n  color: var(--color-ide-text-dim);\n  font-size: 13px;\n  text-align: center;\n}\n\n/* Divider separating runnable commands from those unavailable in the\n   current context. */\n.command-palette-divider {\n  padding: 4px 14px;\n  margin-top: 4px;\n  border-top: 1px solid var(--color-ide-border);\n  color: var(--color-ide-text-dim);\n  font-size: 10px;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  user-select: none;\n}\n\n/* A command that exists but isn't valid in the current context: greyed-out\n   and non-interactive. */\n.command-palette-row-disabled {\n  cursor: default;\n  opacity: 0.45;\n}\n\n.command-palette-row-disabled:hover {\n  background-color: transparent;\n}\n\n/* ------------------------------------------------------------------ */\n/* Add Instance Dialog                                                  */\n/* ------------------------------------------------------------------ */\n\n/* Override max-height to show more symbols */\n.add-instance-dialog {\n  max-height: 440px;\n}\n\n/* Two-line row: name on first line, description on second */\n.add-instance-row {\n  padding: 6px 14px;\n  cursor: pointer;\n  transition: background-color 0.05s;\n}\n\n.add-instance-row:hover {\n  background-color: var(--color-ide-surface-2);\n}\n\n.add-instance-row-selected {\n  background-color: rgba(0, 122, 204, 0.3);\n}\n\n.add-instance-row-selected:hover {\n  background-color: rgba(0, 122, 204, 0.35);\n}\n\n.add-instance-row-name {\n  font-size: 13px;\n  color: var(--color-ide-text);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.add-instance-row-description {\n  font-size: 11px;\n  color: var(--color-ide-text-muted);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  margin-top: 1px;\n}\n\n/* Section headers for PDK/Generic grouping */\n.add-instance-section-header {\n  padding: 6px 14px 3px;\n  font-size: 10px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: var(--color-ide-text-dim);\n  user-select: none;\n}\n\n/* Parameter form */\n.add-instance-params {\n  padding: 8px 14px;\n  overflow-y: auto;\n  flex: 1;\n  min-height: 0;\n}\n\n.add-instance-param-field {\n  margin-bottom: 8px;\n}\n\n.add-instance-param-label {\n  display: block;\n  font-size: 12px;\n  color: var(--color-ide-text);\n  margin-bottom: 3px;\n}\n\n.add-instance-param-hint {\n  color: var(--color-ide-text-dim);\n  font-size: 11px;\n}\n\n.add-instance-param-input {\n  width: 100%;\n  padding: 5px 8px;\n  border: 1px solid var(--color-ide-border);\n  border-radius: 3px;\n  background-color: var(--color-ide-bg);\n  color: var(--color-ide-text);\n  font-family: \"Inconsolata\", ui-monospace, monospace;\n  font-size: 12px;\n  outline: none;\n  box-sizing: border-box;\n}\n\n.add-instance-param-input:focus {\n  border-color: var(--color-ide-accent);\n}\n\n.add-instance-param-input-error {\n  border-color: var(--color-ide-error);\n}\n\n.add-instance-param-input-error:focus {\n  border-color: var(--color-ide-error);\n}\n\n.add-instance-param-input-shake {\n  animation: param-shake 0.4s ease-in-out;\n}\n\n@keyframes param-shake {\n  0%,\n  100% {\n    transform: translateX(0);\n  }\n  20%,\n  60% {\n    transform: translateX(-4px);\n  }\n  40%,\n  80% {\n    transform: translateX(4px);\n  }\n}\n\n.add-instance-param-constraint {\n  display: block;\n  font-size: 11px;\n  color: var(--color-ide-text-dim);\n  font-style: italic;\n  margin-top: 2px;\n}\n\n.add-instance-param-error {\n  display: block;\n  font-size: 11px;\n  color: var(--color-ide-error);\n  margin-top: 2px;\n}\n\n/* Footer with hint text and action button */\n.add-instance-shape-field {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 0 14px 8px;\n  font-size: 12px;\n  color: var(--color-ide-text);\n}\n\n.add-instance-shape-field input {\n  margin: 0;\n}\n\n.add-instance-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 6px 14px;\n  border-top: 1px solid var(--color-ide-border);\n}\n\n.add-instance-hint {\n  font-size: 11px;\n  color: var(--color-ide-text-dim);\n}\n\n.add-instance-btn {\n  padding: 4px 12px;\n  border: 1px solid var(--color-ide-border);\n  border-radius: 3px;\n  background-color: var(--color-ide-accent);\n  color: #fff;\n  font-size: 12px;\n  font-family: inherit;\n  cursor: pointer;\n}\n\n.add-instance-btn:hover {\n  opacity: 0.9;\n}\n\n.add-instance-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* ------------------------------------------------------------------ */\n/* Dropdown menu                                                        */\n/* ------------------------------------------------------------------ */\n\n.ide-dropdown-menu {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  min-width: 180px;\n  background-color: var(--color-ide-surface);\n  border: 1px solid var(--color-ide-border);\n  border-radius: 4px;\n  box-shadow: 0 4px 12px var(--color-ide-shadow-light);\n  z-index: 1000;\n  padding: 4px 0;\n}\n\n.ide-dropdown-item {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: 6px 12px;\n  border: none;\n  background: none;\n  color: var(--color-ide-text);\n  font-size: 12px;\n  font-family: inherit;\n  cursor: pointer;\n  text-align: left;\n}\n\n.ide-dropdown-item:hover {\n  background-color: var(--color-ide-accent);\n  color: #fff;\n}\n\n.ide-dropdown-divider {\n  height: 1px;\n  background-color: var(--color-ide-border);\n  margin: 4px 0;\n}\n\n/* Collapsed panel tab — narrow tab showing just a letter */\n.ide-collapsed-tab {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 100%;\n  cursor: pointer;\n  user-select: none;\n  transition: background-color 0.1s;\n}\n\n.ide-collapsed-tab:hover {\n  background-color: var(--color-ide-hover-overlay);\n}\n\n.ide-collapsed-tab-letter {\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--color-ide-text-muted);\n  text-transform: uppercase;\n}\n\n/* Make dockview tab narrower when it contains a collapsed panel */\n.dockview-theme-abyss .dv-tab:has(.ide-collapsed-tab) {\n  flex: 0 0 auto !important;\n  min-width: 0 !important;\n  width: auto !important;\n  padding: 0 !important;\n}\n\n/* Panel header dropdown menu — rendered via portal with fixed positioning */\n.ide-panel-dropdown-menu {\n  min-width: 140px;\n  background-color: var(--color-ide-surface);\n  border: 1px solid var(--color-ide-border);\n  border-radius: 4px;\n  box-shadow: 0 4px 12px var(--color-ide-shadow-light);\n  z-index: 10000;\n  padding: 4px 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
